<div class="d-flex flex-row-reverse">
  <button
    mat-raised-button
    color="primary"
    (click)="dialogRef.close()"
    style="color: white"
  >
    Close
  </button>
</div>
<mat-drawer-container class="container">
  <mat-drawer mode="side" opened [disableClose]="true">
    <mat-nav-list>
      <a
        mat-list-item
        [class.selected]="selectedNav === 'profile'"
        (click)="selectedNav = 'profile'"
        [disabled]="disableNavigation == true"
        >Personal Details</a
      >
      <a
        mat-list-item
        [class.selected]="selectedNav === 'address'"
        (click)="selectedNav = 'address'"
        [disabled]="disableNavigation == true"
        >Address Details
      </a>
      <a
        mat-list-item
        [class.selected]="selectedNav === 'educationalBackground'"
        (click)="selectedNav = 'educationalBackground'"
        [disabled]="disableNavigation == true"
        >Educational Background
      </a>
      <a
        mat-list-item
        [class.selected]="selectedNav === 'technicalVocational'"
        (click)="selectedNav = 'technicalVocational'"
        [disabled]="disableNavigation == true"
        >Technical/Vocational Other Training
      </a>
      <a
        mat-list-item
        [class.selected]="selectedNav === 'eligibilityProfessionalLicense'"
        (click)="selectedNav = 'eligibilityProfessionalLicense'"
        [disabled]="disableNavigation == true"
        >Eligibility/Professional License
      </a>
      <a
        mat-list-item
        [class.selected]="selectedNav === 'workExpercience'"
        (click)="selectedNav = 'workExpercience'"
        [disabled]="disableNavigation == true"
        >Work Experience
      </a>
      <a
        mat-list-item
        [class.selected]="selectedNav === 'otherSkillsWithoutCertificate'"
        (click)="selectedNav = 'otherSkillsWithoutCertificate'"
        [disabled]="disableNavigation == true"
        >Other Skills Acquired Without Certificate
      </a>
      <a
        mat-list-item
        [class.selected]="selectedNav === 'identification'"
        (click)="selectedNav = 'identification'"
        [disabled]="disableNavigation == true"
        >Identification</a
      >
    </mat-nav-list>
  </mat-drawer>

  <mat-drawer-content>
    <div *ngIf="selectedNav === 'profile'">
      <!-- View Mode -->
      <ng-template #viewModePersonal>
        <div class="row section">
          <form
            [formGroup]="viewPersonalDetailsGroup"
            #editFormPersonal="ngForm"
          >
            <div class="row">
              <div class="col col-lg-3 mb-3">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>First Name</mat-label>
                  <input
                    matInput
                    formControlName="firstName"
                    appCharactersOnly
                    appNoLeadingSpaces
                  />
                </mat-form-field>
                <div *ngIf="personalDetailsGroup.get('firstName').errors">
                  <div>
                    <span
                      class="text text-danger"
                      *ngIf="
                        personalDetailsGroup.get('firstName').errors.pattern
                      "
                    >
                      Please enter small and capital letters only.
                    </span>
                  </div>
                </div>
                <mat-hint class="filipino-translation-hint">Pangalan</mat-hint>
              </div>
              <div class="col col-lg-3 mb-3">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Middle Name</mat-label>
                  <input
                    matInput
                    formControlName="middleName"
                    appCharactersOnly
                    appNoLeadingSpaces
                  />
                </mat-form-field>
                <div *ngIf="personalDetailsGroup.get('middleName').errors">
                  <div>
                    <span
                      class="text text-danger"
                      *ngIf="
                        personalDetailsGroup.get('middleName').errors.pattern
                      "
                    >
                      Please enter small and capital letters only.
                    </span>
                  </div>
                </div>
                <mat-hint class="filipino-translation-hint"
                  >Gitnang Pangalan</mat-hint
                >
              </div>
              <div class="col col-lg-3 mb-3">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Last Name</mat-label>
                  <input
                    matInput
                    formControlName="lastName"
                    appCharactersOnly
                    appNoLeadingSpaces
                  />
                </mat-form-field>
                <div *ngIf="personalDetailsGroup.get('lastName').errors">
                  <div>
                    <span
                      class="text text-danger"
                      *ngIf="
                        personalDetailsGroup.get('lastName').errors.pattern
                      "
                    >
                      Please enter small and capital letters only.
                    </span>
                  </div>
                </div>
                <mat-hint class="filipino-translation-hint">Apelyido</mat-hint>
              </div>
              <div class="col col-lg-3 mb-3">
                <mat-form-field appearance="outline">
                  <mat-label>Suffix</mat-label>
                  <mat-select formControlName="suffix">
                    <mat-option
                      *ngFor="let suffix of suffixes"
                      value="{{ suffix.name }}"
                    >
                      {{ suffix.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12 col-lg-1">
                <mat-label>Height</mat-label>
                <br />
                <mat-hint class="filipino-translation-hint">Tangkad</mat-hint>
              </div>
              <div class="col col-lg-2 mb-3">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Feet</mat-label>
                  <input
                    matInput
                    formControlName="heightFt"
                    appNumericOnlySingle
                    maxlength="1"
                    min="1"
                    max="9"
                    type="number"
                  />
                </mat-form-field>
              </div>
              <div class="col-12 col-lg-2">
                <mat-form-field appearance="outline" [style.width.%]="he100">
                  <mat-label>Inches</mat-label>
                  <input
                    matInput
                    formControlName="heightInches"
                    appNumericOnlyDouble
                    type="number"
                    min="0"
                    max="11"
                  />
                </mat-form-field>
                <div></div>
              </div>
              <div class="col-12 col-lg-1 mb-3">
                <mat-label>Weight</mat-label>
                <br />
                <mat-hint class="filipino-translation-hint">Timbang</mat-hint>
              </div>
              <div class="col-12 col-lg-6 mb-3">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>kilograms</mat-label>
                  <input
                    matInput
                    formControlName="weight"
                    type="number"
                    appNumericOnlyThree
                    min="1"
                    max="400"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12 col-lg-6">
                <mat-form-field appearance="outline">
                  <mat-label>Civil Status</mat-label>
                  <mat-select formControlName="civilStatus">
                    <mat-option
                      *ngFor="let civilStatusType of civilStatusTypes"
                      value="{{ civilStatusType.name }}"
                    >
                      {{ civilStatusType.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint"
                  >Katayuang sibil</mat-hint
                >
              </div>
              <div class="col-lg-6">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Citizenship</mat-label>
                  <input
                    type="text"
                    matInput
                    formControlName="citizenship"
                    appCharactersOnly
                    appNoLeadingSpaces
                    [matAutocomplete]="auto"
                  />
                  <mat-autocomplete
                    #auto="matAutocomplete"
                    mat-autocomplete-panel-below
                  >
                    <mat-option
                      *ngFor="let citizenship of filteredCitizenships | async"
                      [value]="citizenship.name"
                    >
                      {{ citizenship.name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint"
                  >Pagkamamamayan</mat-hint
                >
              </div>
            </div>
            <div class="row mb-3">
              <div
                class="col-12 col-lg-{{
                  personalDetailsGroup.get('religion').value !== 'Others'
                    ? '6'
                    : '4'
                }} "
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Gender</mat-label>
                  <mat-select
                    formControlName="gender"
                    [(value)]="genderSelected"
                  >
                    <mat-option
                      *ngFor="let gender of genders"
                      value="{{ gender.id }}"
                      >{{ gender.name }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint">Kasarian</mat-hint>
              </div>
              <div
                class="col-12 col-lg-{{
                  personalDetailsGroup.get('religion').value !== 'Others'
                    ? '6'
                    : '4'
                }} "
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Religion</mat-label>
                  <input
                    type="text"
                    matInput
                    placeholder="Select a religion"
                    formControlName="religion"
                    [matAutocomplete]="autoReligion"
                    appCharactersOnly
                    appNoLeadingSpaces
                  />
                  <mat-autocomplete #autoReligion="matAutocomplete">
                    <mat-option
                      *ngFor="let religion of filteredReligions | async"
                      [value]="religion.name"
                      >{{ religion.name }}</mat-option
                    >
                  </mat-autocomplete>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint">Relihiyon</mat-hint>
              </div>
              <div
                class="col-12 col-lg-4"
                *ngIf="personalDetailsGroup.get('religion').value == 'Others'"
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Specify</mat-label>
                  <input matInput formControlName="othersReligion" />
                </mat-form-field>
                <mat-hint class="filipino-translation-hint">Tukuyin</mat-hint>
                <div *ngIf="personalDetailsGroup.get('othersReligion').errors">
                  <span
                    class="text text-danger"
                    *ngIf="
                      personalDetailsGroup.get('othersReligion').errors.pattern
                    "
                  >
                    Please enter small and capital letters only
                  </span>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12 col-lg-4">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Birthdate</mat-label>
                  <input matInput formControlName="birthDate" />
                </mat-form-field>
                <mat-hint class="filipino-translation-hint"
                  >Araw ng kapanganakan</mat-hint
                >
                <div *ngIf="personalDetailsGroup.get('birthDate').errors">
                  <div>
                    <span
                      class="text text-danger"
                      *ngIf="
                        personalDetailsGroup.get('birthDate').errors.underage
                      "
                    >
                      You must officially be at least 15 years old to work.
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-4">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Birthplace</mat-label>
                  <input
                    matInput
                    formControlName="birthPlace"
                    appCharactersOnly
                  />
                </mat-form-field>
                <mat-hint class="filipino-translation-hint"
                  >Lugar ng kapanganakan</mat-hint
                >
                <div *ngIf="personalDetailsGroup.get('birthPlace').errors">
                  <div>
                    <span
                      class="text text-danger"
                      *ngIf="
                        personalDetailsGroup.get('birthPlace').errors.pattern
                      "
                    >
                      Please enter small and capital letters only.
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-4">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Taxpayer Identification Number</mat-label>
                  <input
                    matInput
                    formControlName="tin"
                    appAlphaNumericDashOnly
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="row mb">
              <div class="col-lg-6">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Disability Status</mat-label>
                  <mat-select
                    [(ngModel)]="selectedDisability"
                    formControlName="disabilityStatus"
                    multiple
                    (selectionChange)="onSelectionChange($event)"
                  >
                    <mat-option
                      *ngFor="let disabilityStatus of disabilityStatuses"
                      [value]="disabilityStatus.name"
                      [disabled]="disableOption(disabilityStatus.name)"
                    >
                      {{ disabilityStatus.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-hint class="filipino-translation-hint mb-2"
                  >Kapansanan</mat-hint
                >
              </div>
              <div class="col-lg-6">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Contact Number</mat-label>
                  <input
                    matInput
                    formControlName="contactNumber"
                    placeholder="ex: 09281361468"
                    type="text"
                    maxlength="15"
                    appNumericOnlyZeroNine
                  />
                </mat-form-field>
              </div>
            </div>
          </form>
        </div>
      </ng-template>
      <!-- Edit Mode -->
      <div *ngIf="isPersonalDetailsEditMode; else viewModePersonal">
        <div class="row section">
          <form [formGroup]="personalDetailsGroup" #editFormPersonal="ngForm">
            <div class="row">
              <div class="col col-lg-3 mb-3">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>First Name</mat-label>
                  <input
                    matInput
                    formControlName="firstName"
                    appCharactersOnly
                    appNoLeadingSpaces
                  />
                </mat-form-field>
                <div *ngIf="personalDetailsGroup.get('firstName').errors">
                  <div>
                    <span
                      class="text text-danger"
                      *ngIf="
                        personalDetailsGroup.get('firstName').errors.pattern
                      "
                    >
                      Please enter small and capital letters only.
                    </span>
                  </div>
                </div>
                <mat-hint class="filipino-translation-hint">Pangalan</mat-hint>
              </div>
              <div class="col col-lg-3 mb-3">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Middle Name</mat-label>
                  <input
                    matInput
                    formControlName="middleName"
                    appCharactersOnly
                    appNoLeadingSpaces
                  />
                </mat-form-field>
                <div *ngIf="personalDetailsGroup.get('middleName').errors">
                  <div>
                    <span
                      class="text text-danger"
                      *ngIf="
                        personalDetailsGroup.get('middleName').errors.pattern
                      "
                    >
                      Please enter small and capital letters only.
                    </span>
                  </div>
                </div>
                <mat-hint class="filipino-translation-hint"
                  >Gitnang Pangalan</mat-hint
                >
              </div>
              <div class="col col-lg-3 mb-3">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Last Name</mat-label>
                  <input
                    matInput
                    formControlName="lastName"
                    appCharactersOnly
                    appNoLeadingSpaces
                  />
                </mat-form-field>
                <div *ngIf="personalDetailsGroup.get('lastName').errors">
                  <div>
                    <span
                      class="text text-danger"
                      *ngIf="
                        personalDetailsGroup.get('lastName').errors.pattern
                      "
                    >
                      Please enter small and capital letters only.
                    </span>
                  </div>
                </div>
                <mat-hint class="filipino-translation-hint">Apelyido</mat-hint>
              </div>
              <div class="col col-lg-3 mb-3">
                <mat-form-field appearance="outline">
                  <mat-label>Suffix</mat-label>
                  <mat-select formControlName="suffix">
                    <mat-option
                      *ngFor="let suffix of suffixes"
                      value="{{ suffix.name }}"
                    >
                      {{ suffix.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12 col-lg-1">
                <mat-label>Height</mat-label>
                <br />
                <mat-hint class="filipino-translation-hint">Tangkad</mat-hint>
              </div>
              <div class="col col-lg-2 mb-3">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Feet</mat-label>
                  <input
                    matInput
                    formControlName="heightFt"
                    appNumericOnlySingle
                    maxlength="1"
                    min="1"
                    max="9"
                    type="number"
                  />
                </mat-form-field>
              </div>
              <div class="col-12 col-lg-2">
                <mat-form-field appearance="outline" [style.width.%]="he100">
                  <mat-label>Inches</mat-label>
                  <input
                    matInput
                    formControlName="heightInches"
                    appNumericOnlyDouble
                    type="number"
                    min="0"
                    max="11"
                  />
                </mat-form-field>
                <div></div>
              </div>
              <div class="col-12 col-lg-1 mb-3">
                <mat-label>Weight</mat-label>
                <br />
                <mat-hint class="filipino-translation-hint">Timbang</mat-hint>
              </div>
              <div class="col-12 col-lg-6 mb-3">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>kilograms</mat-label>
                  <input
                    matInput
                    formControlName="weight"
                    type="number"
                    appNumericOnlyThree
                    min="1"
                    max="400"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12 col-lg-6">
                <mat-form-field appearance="outline">
                  <mat-label>Civil Status</mat-label>
                  <mat-select formControlName="civilStatus">
                    <mat-option
                      *ngFor="let civilStatusType of civilStatusTypes"
                      value="{{ civilStatusType.name }}"
                    >
                      {{ civilStatusType.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint"
                  >Katayuang sibil</mat-hint
                >
              </div>
              <div class="col-lg-6">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Citizenship</mat-label>
                  <input
                    type="text"
                    matInput
                    formControlName="citizenship"
                    appCharactersOnly
                    appNoLeadingSpaces
                    [matAutocomplete]="auto"
                  />
                  <mat-autocomplete
                    #auto="matAutocomplete"
                    mat-autocomplete-panel-below
                  >
                    <mat-option
                      *ngFor="let citizenship of filteredCitizenships | async"
                      [value]="citizenship.name"
                    >
                      {{ citizenship.name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint"
                  >Pagkamamamayan</mat-hint
                >
              </div>
            </div>
            <div class="row mb-3">
              <div
                class="col-12 col-lg-{{
                  personalDetailsGroup.get('religion').value !== 'Others'
                    ? '6'
                    : '4'
                }} "
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Gender</mat-label>
                  <mat-select
                    formControlName="gender"
                    [(value)]="genderSelected"
                  >
                    <mat-option
                      *ngFor="let gender of genders"
                      value="{{ gender.id }}"
                      >{{ gender.name }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint">Kasarian</mat-hint>
              </div>
              <div
                class="col-12 col-lg-{{
                  personalDetailsGroup.get('religion').value !== 'Others'
                    ? '6'
                    : '4'
                }} "
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Religion</mat-label>
                  <input
                    type="text"
                    matInput
                    placeholder="Select a religion"
                    formControlName="religion"
                    [matAutocomplete]="autoReligion"
                    appCharactersOnly
                    appNoLeadingSpaces
                  />
                  <mat-autocomplete #autoReligion="matAutocomplete">
                    <mat-option
                      *ngFor="let religion of filteredReligions | async"
                      [value]="religion.name"
                      >{{ religion.name }}</mat-option
                    >
                  </mat-autocomplete>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint">Relihiyon</mat-hint>
              </div>
              <div
                class="col-12 col-lg-4"
                *ngIf="personalDetailsGroup.get('religion').value == 'Others'"
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Specify</mat-label>
                  <input matInput formControlName="othersReligion" />
                </mat-form-field>
                <mat-hint class="filipino-translation-hint">Tukuyin</mat-hint>
                <div *ngIf="personalDetailsGroup.get('othersReligion').errors">
                  <span
                    class="text text-danger"
                    *ngIf="
                      personalDetailsGroup.get('othersReligion').errors.pattern
                    "
                  >
                    Please enter small and capital letters only
                  </span>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12 col-lg-4">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Birthdate</mat-label>
                  <input matInput formControlName="birthDate" />
                </mat-form-field>
                <mat-hint class="filipino-translation-hint"
                  >Araw ng kapanganakan</mat-hint
                >
                <div *ngIf="personalDetailsGroup.get('birthDate').errors">
                  <div>
                    <span
                      class="text text-danger"
                      *ngIf="
                        personalDetailsGroup.get('birthDate').errors.underage
                      "
                    >
                      You must officially be at least 15 years old to work.
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-4">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Birthplace</mat-label>
                  <input
                    matInput
                    formControlName="birthPlace"
                    appCharactersOnly
                  />
                </mat-form-field>
                <mat-hint class="filipino-translation-hint"
                  >Lugar ng kapanganakan</mat-hint
                >
                <div *ngIf="personalDetailsGroup.get('birthPlace').errors">
                  <div>
                    <span
                      class="text text-danger"
                      *ngIf="
                        personalDetailsGroup.get('birthPlace').errors.pattern
                      "
                    >
                      Please enter small and capital letters only.
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-4">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Taxpayer Identification Number</mat-label>
                  <input
                    matInput
                    formControlName="tin"
                    appAlphaNumericDashOnly
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="row mb">
              <div class="col-lg-6">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Disability Status</mat-label>
                  <mat-select
                    [(ngModel)]="selectedDisability"
                    formControlName="disabilityStatus"
                    multiple
                    (selectionChange)="onSelectionChange($event)"
                  >
                    <mat-option
                      *ngFor="let disabilityStatus of disabilityStatuses"
                      [value]="disabilityStatus.name"
                      [disabled]="disableOption(disabilityStatus.name)"
                    >
                      {{ disabilityStatus.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-hint class="filipino-translation-hint mb-2"
                  >Kapansanan</mat-hint
                >
              </div>
              <div class="col-lg-6">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Contact Number</mat-label>
                  <input
                    matInput
                    formControlName="contactNumber"
                    placeholder="ex: 09281361468"
                    type="text"
                    maxlength="15"
                    appNumericOnlyZeroNine
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="row mb-3"></div>
          </form>
        </div>
      </div>
    </div>
    <div *ngIf="selectedNav === 'address'">
      <!-- View Mode -->
      <ng-template #viewAddress>
        <div class="row section">
          <form [formGroup]="viewAddressDetailsGroup">
            <div class="col-12 mb-2">
              <mat-label class="label">Present Address</mat-label>
              <br />
              <mat-hint class="filipino-translation-hint"
                >Kasalukuyang Tinitirahan</mat-hint
              >
            </div>
            <div class="row">
              <div class="col-lg-4">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Region</mat-label>
                  <mat-select
                    [(ngModel)]="selectedRegion"
                    (selectionChange)="onRegionChanged($event)"
                    formControlName="presentRegionId"
                  >
                    <mat-option
                      *ngFor="let region of regions"
                      [value]="region.id"
                    >
                      {{ region.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint">Rehiyon</mat-hint>
              </div>
              <div class="col-lg-4">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Province</mat-label>
                  <mat-select
                    [(ngModel)]="selectedProvince"
                    (selectionChange)="onProvinceChanged($event)"
                    formControlName="presentProvinceId"
                  >
                    <mat-option
                      *ngFor="let province of provinces"
                      [value]="province.id"
                    >
                      {{ province.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint">Lalawigan</mat-hint>
              </div>
              <div class="col-lg-4">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>City/Municipalities</mat-label>
                  <mat-select
                    [(ngModel)]="selectedCityMunicipality"
                    formControlName="presentCityId"
                    (selectionChange)="onCityMunicipalityChangePresent($event)"
                  >
                    <mat-option
                      *ngFor="let city of citiesMunicipalities"
                      [value]="city.id"
                    >
                      {{ city.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint"
                  >Lungsod o Munisipalidad</mat-hint
                >
              </div>
            </div>
            <div class="row">
              <div
                class="col-12 col-lg-6 mb-3"
                *ngIf="selectedCityMunicipality != '1591'"
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Barangay</mat-label>
                  <input
                    matInput
                    formControlName="presentBarangay"
                    appNoLeadingSpaces
                  />
                </mat-form-field>
                <div *ngIf="addressDetailsGroup.get('presentBarangay').errors">
                  <span
                    class="text text-danger"
                    *ngIf="
                      addressDetailsGroup.get('presentBarangay').touched &&
                      addressDetailsGroup.get('presentBarangay').errors.required
                    "
                  >
                    Barangay is required
                  </span>
                </div>
              </div>
              <div
                class="col-12 col-lg-6 mb-3"
                *ngIf="selectedCityMunicipality == '1591'"
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Barangay</mat-label>
                  <mat-select
                    [(ngModel)]="selectedBarangayBaguio"
                    formControlName="presentBarangayId"
                  >
                    <mat-option
                      [value]="barangayBaguio.id"
                      *ngFor="let barangayBaguio of barangaysBaguio"
                      >{{ barangayBaguio.name }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
                <div
                  *ngIf="addressDetailsGroup.get('presentBarangayId').errors"
                >
                  <span
                    class="text text-danger"
                    *ngIf="
                      addressDetailsGroup.get('presentBarangayId').touched &&
                      addressDetailsGroup.get('presentBarangayId').errors
                        .required
                    "
                  >
                    Barangay is required
                  </span>
                </div>
              </div>
              <div class="col-12 col-lg-6 mb-3">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>House No.,Bldg, Street</mat-label>
                  <input
                    matInput
                    formControlName="presentStreetName"
                    appNoLeadingSpaces
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <mat-label class="label">
                Permanent address same with present address?
              </mat-label>
              <mat-hint class="filipino-translation-hint"
                >Pareho ba ang iyong permanenteng address sa iyong kasalukuyang
                address?</mat-hint
              >
            </div>
            <div class="row">
              <mat-radio-group
                aria-label="Select an option"
                formControlName="isAddressPresentEqualToPermanent"
                (change)="onPermanentAddressStatusChange($event)"
              >
                <mat-radio-button [value]="1" class="mr-3"
                  >Yes
                </mat-radio-button>
                <mat-radio-button [value]="2" class="mr-3"
                  >No
                </mat-radio-button>
              </mat-radio-group>
            </div>
            <div
              class="row"
              *ngIf="
                this.viewAddressDetailsGroup.controls
                  .isAddressPresentEqualToPermanent.value == 2
              "
            >
              <mat-label class="label">Permanent Address</mat-label>
              <br />
              <mat-hint class="filipino-translation-hint"
                >Permanenteng Tinitirahan</mat-hint
              >
              <div class="col-lg-4">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Region</mat-label>
                  <mat-select
                    [(ngModel)]="selectedRegionPermanent"
                    (selectionChange)="onRegionChangedPermanent($event)"
                    formControlName="permanentRegionId"
                  >
                    <mat-option
                      *ngFor="let regionPermanent of regionsPermanent"
                      [value]="regionPermanent.id"
                    >
                      {{ regionPermanent.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint">Rehiyon</mat-hint>
              </div>
              <div class="col-lg-4">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Province</mat-label>
                  <mat-select
                    [(ngModel)]="selectedProvincePermanent"
                    (selectionChange)="onProvinceChangedPermanent($event)"
                    formControlName="permanentProvinceId"
                  >
                    <mat-option
                      *ngFor="let provincePermanent of provincesPermanent"
                      [value]="provincePermanent.id"
                    >
                      {{ provincePermanent.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint">Lalawigan</mat-hint>
              </div>
              <div class="col-lg-4">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>City/Municipalities</mat-label>
                  <mat-select
                    [(ngModel)]="selectedCityMunicipalityPermanent"
                    formControlName="permanentCityId"
                    (selectionChange)="
                      onCityMunicipalityChangePermanent($event)
                    "
                  >
                    <mat-option
                      *ngFor="
                        let itemPermanent of citiesMunicipalitiesPermanent
                      "
                      [value]="itemPermanent.id"
                    >
                      {{ itemPermanent.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint"
                  >Lungsod o Munisipalidad</mat-hint
                >
              </div>
              <div
                class="col-lg-6"
                *ngIf="selectedCityMunicipalityPermanent != '1591'"
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Barangay</mat-label>
                  <input
                    matInput
                    formControlName="permanentBarangay"
                    appNoLeadingSpaces
                  />
                </mat-form-field>
              </div>
              <div
                class="col-lg-6"
                *ngIf="selectedCityMunicipalityPermanent == '1591'"
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Barangay</mat-label>
                  <mat-select
                    [(ngModel)]="selectedBarangayBaguioPermanent"
                    formControlName="permanentBarangayId"
                  >
                    <mat-option
                      [value]="barangayBaguio.id"
                      *ngFor="let barangayBaguio of barangaysBaguio"
                      >{{ barangayBaguio.name }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-lg-6">
                <mat-form-field
                  appearance="outline"
                  [style.width.%]="100"
                  class="mb-3"
                >
                  <mat-label>House No., Bldg, Street</mat-label>
                  <input
                    matInput
                    formControlName="permanentStreetName"
                    appNoLeadingSpaces
                  />
                </mat-form-field>
              </div>
            </div>
          </form>
        </div>
      </ng-template>
      <!-- Edit Mode -->
      <div *ngIf="isAddressDetailsEditMode; else viewAddress">
        <div class="row section">
          <form [formGroup]="addressDetailsGroup">
            <div class="col-12 mb-2">
              <mat-label class="label">Present Address</mat-label>
              <br />
              <mat-hint class="filipino-translation-hint"
                >Kasalukuyang Tinitirahan</mat-hint
              >
            </div>
            <div class="row">
              <div class="col-lg-4">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Region</mat-label>
                  <mat-select
                    [(ngModel)]="selectedRegion"
                    (selectionChange)="onRegionChanged($event)"
                    formControlName="presentRegionId"
                  >
                    <mat-option
                      *ngFor="let region of regions"
                      [value]="region.id"
                    >
                      {{ region.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint">Rehiyon</mat-hint>
              </div>
              <div class="col-lg-4">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Province</mat-label>
                  <mat-select
                    [(ngModel)]="selectedProvince"
                    (selectionChange)="onProvinceChanged($event)"
                    formControlName="presentProvinceId"
                  >
                    <mat-option
                      *ngFor="let province of provinces"
                      [value]="province.id"
                    >
                      {{ province.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint">Lalawigan</mat-hint>
              </div>
              <div class="col-lg-4">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>City/Municipalities</mat-label>
                  <mat-select
                    [(ngModel)]="selectedCityMunicipality"
                    formControlName="presentCityId"
                    (selectionChange)="onCityMunicipalityChangePresent($event)"
                  >
                    <mat-option
                      *ngFor="let city of citiesMunicipalities"
                      [value]="city.id"
                    >
                      {{ city.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint"
                  >Lungsod o Munisipalidad</mat-hint
                >
              </div>
            </div>
            <div class="row">
              <div
                class="col-12 col-lg-6 mb-3"
                *ngIf="selectedCityMunicipality != '1591'"
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Barangay</mat-label>
                  <input
                    matInput
                    formControlName="presentBarangay"
                    appNoLeadingSpaces
                  />
                </mat-form-field>
                <div *ngIf="addressDetailsGroup.get('presentBarangay').errors">
                  <span
                    class="text text-danger"
                    *ngIf="
                      addressDetailsGroup.get('presentBarangay').touched &&
                      addressDetailsGroup.get('presentBarangay').errors.required
                    "
                  >
                    Barangay is required
                  </span>
                </div>
              </div>
              <div
                class="col-12 col-lg-6 mb-3"
                *ngIf="selectedCityMunicipality == '1591'"
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Barangay</mat-label>
                  <mat-select
                    [(ngModel)]="selectedBarangayBaguio"
                    formControlName="presentBarangayId"
                  >
                    <mat-option
                      [value]="barangayBaguio.id"
                      *ngFor="let barangayBaguio of barangaysBaguio"
                      >{{ barangayBaguio.name }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
                <div
                  *ngIf="addressDetailsGroup.get('presentBarangayId').errors"
                >
                  <span
                    class="text text-danger"
                    *ngIf="
                      addressDetailsGroup.get('presentBarangayId').touched &&
                      addressDetailsGroup.get('presentBarangayId').errors
                        .required
                    "
                  >
                    Barangay is required
                  </span>
                </div>
              </div>
              <div class="col-12 col-lg-6 mb-3">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>House No.,Bldg, Street</mat-label>
                  <input
                    matInput
                    formControlName="presentStreetName"
                    appNoLeadingSpaces
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <mat-label class="label">
                Is permanent address same with present address?
              </mat-label>
              <mat-hint class="filipino-translation-hint"
                >Pareho ba ang iyong permanenteng address sa iyong kasalukuyang
                address?</mat-hint
              >
            </div>
            <div class="row">
              <mat-radio-group
                aria-label="Select an option"
                formControlName="isAddressPresentEqualToPermanent"
                (change)="onPermanentAddressStatusChange($event)"
              >
                <mat-radio-button [value]="1" class="mr-3"
                  >Yes
                </mat-radio-button>
                <mat-radio-button [value]="2" class="mr-3"
                  >No
                </mat-radio-button>
              </mat-radio-group>
            </div>
            <div
              class="row"
              *ngIf="
                this.addressDetailsGroup.controls
                  .isAddressPresentEqualToPermanent.value == 2
              "
            >
              <mat-label class="label">Permanent Address</mat-label>
              <br />
              <mat-hint class="filipino-translation-hint"
                >Permanenteng Tinitirahan</mat-hint
              >
              <div class="col-lg-4">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Region</mat-label>
                  <mat-select
                    [(ngModel)]="selectedRegionPermanent"
                    (selectionChange)="onRegionChangedPermanent($event)"
                    formControlName="permanentRegionId"
                  >
                    <mat-option
                      *ngFor="let regionPermanent of regionsPermanent"
                      [value]="regionPermanent.id"
                    >
                      {{ regionPermanent.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint">Rehiyon</mat-hint>
              </div>
              <div class="col-lg-4">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Province</mat-label>
                  <mat-select
                    [(ngModel)]="selectedProvincePermanent"
                    (selectionChange)="onProvinceChangedPermanent($event)"
                    formControlName="permanentProvinceId"
                  >
                    <mat-option
                      *ngFor="let provincePermanent of provincesPermanent"
                      [value]="provincePermanent.id"
                    >
                      {{ provincePermanent.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint">Lalawigan</mat-hint>
              </div>
              <div class="col-lg-4">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>City/Municipalities</mat-label>
                  <mat-select
                    [(ngModel)]="selectedCityMunicipalityPermanent"
                    formControlName="permanentCityId"
                  >
                    <mat-option
                      *ngFor="
                        let itemPermanent of citiesMunicipalitiesPermanent
                      "
                      [value]="itemPermanent.id"
                    >
                      {{ itemPermanent.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint"
                  >Lungsod o Munisipalidad</mat-hint
                >
              </div>
              <div
                class="col-lg-6"
                *ngIf="selectedCityMunicipalityPermanent != '1591'"
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Barangay</mat-label>
                  <input
                    matInput
                    formControlName="permanentBarangay"
                    appNoLeadingSpaces
                  />
                </mat-form-field>
              </div>
              <div
                class="col-lg-6"
                *ngIf="selectedCityMunicipalityPermanent == '1591'"
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Barangay</mat-label>
                  <mat-select
                    [(ngModel)]="selectedBarangayBaguioPermanent"
                    formControlName="permanentBarangayId"
                  >
                    <mat-option
                      [value]="barangayBaguio.id"
                      *ngFor="let barangayBaguio of barangaysBaguio"
                      >{{ barangayBaguio.name }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-lg-6">
                <mat-form-field
                  appearance="outline"
                  [style.width.%]="100"
                  class="mb-3"
                >
                  <mat-label>House No., Bldg, Street</mat-label>
                  <input
                    matInput
                    formControlName="permanentStreetName"
                    appNoLeadingSpaces
                  />
                </mat-form-field>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div *ngIf="selectedNav === 'technicalVocational'">
      <div class="row section">
        <table
          mat-table
          [dataSource]="dataSourceTechnicalTrainings"
          class="table-responsive mb-3"
          style="border: 1px solid #00943a"
          #technicalTrainingTable
        >
          <!-- ID -->
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef [hidden]="true">ID</th>
            <td
              mat-cell
              *matCellDef="let element"
              class="table-column"
              [hidden]="true"
            >
              {{ element.id }}
            </td>
          </ng-container>

          <!-- Training/Vocationl Course  Column -->
          <ng-container matColumnDef="trainingCourse">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="table-heading"
            >
              Training/Vocational Course
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="table-cell table-heading-element"
            >
              {{ element.trainingCourse }}
            </td>
          </ng-container>

          <!-- Hours of Training Column -->
          <ng-container matColumnDef="hoursOfTraining">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="table-heading"
            >
              Hours of training
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="table-cell table-heading-element"
            >
              {{ element.hoursOfTraining }}
            </td>
          </ng-container>

          <!-- Training Institution Column -->
          <ng-container matColumnDef="trainingInstitution">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="table-heading"
            >
              Training Institution
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="table-cell table-heading-element"
            >
              {{ element.trainingInstitution }}
            </td>
          </ng-container>

          <!-- Certificates Received Column -->
          <ng-container matColumnDef="certificates">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="table-heading"
            >
              Certificates Received
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="table-cell table-heading-element"
              >
              {{ element.certificates }}
            </td>
          </ng-container>

          <!-- Skills Acquired Column -->
          <ng-container matColumnDef="skillsAcquired">
            <th
              mat-header-cell
              *matHeaderCellDef
             class="table-cell table-heading"
            >
              Skills acquired
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="table-cell table-heading-element"
            >
              {{ element.skillsAcquired }}
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="table-heading"
            ></th>
            <td
              mat-cell
              *matCellDef="let element"
              style="padding: 1rem; border-bottom: 1px solid #00943a"
              class="table-cell"
            >
              <div class="d-flex justify-content-end">
                <div class="row">
                  <div class="col-lg-12">
                    <mat-icon
                      (click)="updateTechnical(element)"
                      style="margin-right: 0.3rem"
                      >edit</mat-icon
                    >
                    <mat-icon (click)="deleteItemTechnical(element)"
                      >delete</mat-icon
                    >
                  </div>
                </div>
              </div>
            </td>
          </ng-container>
          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumnsTechnicalTrainings"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumnsTechnicalTrainings"
          ></tr>
        </table>
      </div>
    </div>
    <div *ngIf="selectedNav === 'educationalBackground'">
      <!-- View Mode Educational-->
      <ng-template #viewEducational>
        <div class="row section">
          <form [formGroup]="viewEducationalDetailsGroup">
            <div class="row">
              <mat-label class="label">Are you still studyings?</mat-label>
              <mat-hint class="filipino-translation-hint mb-2"
                >Nag-aaral ka pa ba?</mat-hint
              >
              <mat-radio-group formControlName="isStillStudying">
                <mat-radio-button [value]="true" class="radio-buttons-left"
                  >Yes
                </mat-radio-button>
                <mat-radio-button [value]="false" class="radio-buttons-right"
                  >No</mat-radio-button
                >
              </mat-radio-group>
            </div>
            <div class="row">
              <mat-label class="label mb-2">
                Highest educational attainment
              </mat-label>
              <mat-hint class="filipino-translation-hint mb-2"
                >Ano ang iyong pinakamataas na background sa edukasyon?
              </mat-hint>
              <mat-form-field appearance="outline" [style.width.%]="100">
                <mat-label>Educational Attainment</mat-label>
                <mat-select
                  [(ngModel)]="highesEducationAttainment"
                  formControlName="highestEducationLevel"
                >
                  <mat-option [value]="0">No Formal Education</mat-option>
                  <mat-option [value]="1">Elementary Level</mat-option>
                  <mat-option [value]="2">Secondary Level</mat-option>
                  <mat-option [value]="3"
                    >Undergraduate Level (Bachelor's Degree)</mat-option
                  >
                  <mat-option [value]="4"
                    >Graduate Level (Master's Degree)</mat-option
                  >
                  <mat-option [value]="5"
                    >Post Graduate Level (Doctorate Degree)</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <!-- Elementary Level -->
            <div class="row" *ngIf="highesEducationAttainment == 1">
              <mat-label class="label"> Elementary </mat-label>
              <mat-hint class="filipino-translation-hint">Elementarya</mat-hint>
              <div class="col-lg-4">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>School Name</mat-label>
                  <input
                    matInput
                    formControlName="elementarySchool"
                    appNoLeadingSpaces
                  />
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Pangalan ng Paaralan</mat-hint
                >
              </div>
              <div class="col-lg-4">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Level Reached</mat-label>
                  <mat-select formControlName="elementaryLevelReached">
                    <mat-option
                      *ngFor="let elementaryLevel of elementaryLevels"
                      [value]="elementaryLevel.name"
                    >
                      {{ elementaryLevel.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Naabot ang Antas</mat-hint
                >
              </div>
              <div class="col-lg-4">
                <mat-form-field appearance="outline">
                  <mat-label>Year Attended</mat-label>
                  <input
                    matInput
                    placeholder="YYYY"
                    [matDatepicker]="datePicker"
                    formControlName="elementaryYearAttended"
                    appNoLeadingSpaces
                    (focus)="datePicker?.open()"
                    readonly="true"
                    [min]="minDate"
                    [max]="maxDate"
                    [startAt]="currentDate"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="datePicker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker
                    #datePicker
                    color="primary"
                    startView="multi-year"
                    (yearSelected)="
                      onYearSelectedElementary($event, datePicker)
                    "
                  ></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
            <!-- Secondary Level -->
            <div class="row" *ngIf="highesEducationAttainment == 2">
              <mat-label class="label"> Elementary </mat-label>
              <mat-hint class="filipino-translation-hint">Elementarya</mat-hint>
              <div class="col-lg-8">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>School Name</mat-label>
                  <input
                    matInput
                    formControlName="elementarySchool"
                    appNoLeadingSpaces
                  />
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Pangalan ng Paaralan</mat-hint
                >
              </div>
              <div class="col-lg-4">
                <mat-form-field appearance="outline">
                  <mat-label>Year Attended</mat-label>
                  <input
                    matInput
                    placeholder="YYYY"
                    [matDatepicker]="datePicker"
                    formControlName="elementaryYearAttended"
                    appNoLeadingSpaces
                    (focus)="datePicker?.open()"
                    readonly="true"
                    [min]="minDate"
                    [max]="maxDate"
                    [startAt]="currentDate"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="datePicker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker
                    #datePicker
                    color="primary"
                    startView="multi-year"
                    (yearSelected)="
                      onYearSelectedElementary($event, datePicker)
                    "
                  ></mat-datepicker>
                </mat-form-field>
              </div>
              <mat-label class="label">Secondary</mat-label>
              <div class="col-lg-4">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>School Name</mat-label>
                  <input
                    matInput
                    formControlName="highSchool"
                    appNoLeadingSpaces
                  />
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Pangalan ng Paaralan</mat-hint
                >
              </div>
              <div class="col-lg-4">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Level Reached</mat-label>
                  <mat-select formControlName="highSchoolLevelReached">
                    <mat-option
                      *ngFor="let secondaryLevel of secondaryLevels"
                      [value]="secondaryLevel.name"
                    >
                      {{ secondaryLevel.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Naabot ang Antas</mat-hint
                >
              </div>
              <div class="col-lg-4">
                <mat-form-field appearance="outline">
                  <mat-label>Year Attended</mat-label>
                  <input
                    matInput
                    placeholder="YYYY"
                    [matDatepicker]="datePickerHighSchool"
                    formControlName="highSchoolYearAttended"
                    appNoLeadingSpaces
                    (focus)="datePicker?.open()"
                    readonly="true"
                    [min]="
                      educationalBackgroundDetailsGroup.get(
                        'elementaryYearAttended'
                      ).value
                    "
                    [max]="maxDate"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="datePickerHighSchool"
                  ></mat-datepicker-toggle>
                  <mat-datepicker
                    #datePickerHighSchool
                    color="primary"
                    startView="multi-year"
                    (yearSelected)="
                      onYearSelectedSecondary($event, datePickerHighSchool)
                    "
                    [startAt]="currentDate"
                  >
                  </mat-datepicker>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Taon na Dumalo</mat-hint
                >
              </div>
              <mat-label class="label">
                Are you part of the K-12 curriculum?
              </mat-label>
              <mat-radio-group
                formControlName="isAttendedSeniorHigh"
                (change)="onk12RadioButtonsSelect()"
                class="mb-2"
              >
                <mat-radio-button [value]="true" class="radio-buttons-left"
                  >Yes
                </mat-radio-button>
                <mat-radio-button [value]="false" class="radio-buttons-right"
                  >No</mat-radio-button
                >
              </mat-radio-group>
              <div
                class="col-lg-6"
                *ngIf="
                  this.viewEducationalDetailsGroup.controls.isAttendedSeniorHigh
                    .value == true
                "
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>School Name</mat-label>
                  <input
                    matInput
                    formControlName="seniorHighSchool"
                    appNoLeadingSpaces
                  />
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Pangalan ng Paaralan</mat-hint
                >
              </div>
              <div
                class="col-lg-6"
                *ngIf="
                  this.viewEducationalDetailsGroup.controls.isAttendedSeniorHigh
                    .value == true
                "
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Senior High Strand</mat-label>
                  <mat-select formControlName="seniorHighSchoolStrands">
                    <mat-option
                      *ngFor="let strand of k12Strands"
                      [value]="strand.name"
                    >
                      {{ strand.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Strand</mat-hint
                >
              </div>
              <div
                class="col-lg-6"
                *ngIf="
                  this.viewEducationalDetailsGroup.controls.isAttendedSeniorHigh
                    .value == true
                "
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Level Reached</mat-label>
                  <mat-select formControlName="seniorHighSchoolLevelReached">
                    <mat-option
                      *ngFor="let k12Level of k12Levels"
                      [value]="k12Level.name"
                    >
                      {{ k12Level.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Naabot ang Antas</mat-hint
                >
              </div>
              <div
                class="col-lg-6"
                *ngIf="
                  this.viewEducationalDetailsGroup.controls.isAttendedSeniorHigh
                    .value == true
                "
              >
                <mat-form-field appearance="outline">
                  <mat-label>Year Attended</mat-label>
                  <input
                    matInput
                    placeholder="YYYY"
                    [matDatepicker]="datePickerHighk12"
                    formControlName="seniorHighSchoolYearAttended"
                    appNoLeadingSpaces
                    (focus)="datePickerHighk12?.open()"
                    readonly="true"
                    [min]="
                      educationalBackgroundDetailsGroup.get(
                        'highSchoolYearAttended'
                      ).value
                    "
                    [max]="maxDate"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="datePickerHighk12"
                  ></mat-datepicker-toggle>
                  <mat-datepicker
                    #datePickerHighk12
                    color="primary"
                    startView="multi-year"
                    (yearSelected)="
                      onYearSelectedK12($event, datePickerHighk12)
                    "
                    [startAt]="currentDate"
                  >
                  </mat-datepicker>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Taon na Dumalo</mat-hint
                >
              </div>
            </div>
            <!-- Undergraduate Level -->
            <div class="row" *ngIf="highesEducationAttainment == 3">
              <mat-label class="label"> Elementary </mat-label>
              <mat-hint class="filipino-translation-hint">Elementarya</mat-hint>
              <div class="col-lg-8">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>School Name</mat-label>
                  <input
                    matInput
                    formControlName="elementarySchool"
                    appNoLeadingSpaces
                  />
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Pangalan ng Paaralan</mat-hint
                >
              </div>
              <div class="col-lg-4">
                <mat-form-field appearance="outline">
                  <mat-label>Year Attended</mat-label>
                  <input
                    matInput
                    placeholder="YYYY"
                    [matDatepicker]="datePicker"
                    formControlName="elementaryYearAttended"
                    appNoLeadingSpaces
                    (focus)="datePicker?.open()"
                    readonly="true"
                    [max]="maxDate"
                    [startAt]="currentDate"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="datePicker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker
                    #datePicker
                    color="primary"
                    startView="multi-year"
                    (yearSelected)="
                      onYearSelectedElementary($event, datePicker)
                    "
                  ></mat-datepicker>
                </mat-form-field>
              </div>
              <mat-label class="label">Secondary</mat-label>
              <mat-hint class="filipino-translation-hint"
                >Pangalawang lebel (High School/Senior High
                School/K-12)</mat-hint
              >
              <div class="col-lg-8">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>School Name</mat-label>
                  <input
                    matInput
                    formControlName="highSchool"
                    appNoLeadingSpaces
                  />
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Pangalan ng Paaralan</mat-hint
                >
              </div>
              <div class="col-lg-4">
                <mat-form-field appearance="outline">
                  <mat-label>Year Attended</mat-label>
                  <input
                    matInput
                    placeholder="YYYY"
                    [matDatepicker]="datePickerHighSchool"
                    formControlName="highSchoolYearAttended"
                    appNoLeadingSpaces
                    (focus)="datePicker?.open()"
                    readonly="true"
                    [min]="
                      educationalBackgroundDetailsGroup.get(
                        'elementaryYearAttended'
                      ).value
                    "
                    [max]="maxDate"
                    [startAt]="currentDate"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="datePickerHighSchool"
                  ></mat-datepicker-toggle>
                  <mat-datepicker
                    #datePickerHighSchool
                    color="primary"
                    startView="multi-year"
                    (yearSelected)="
                      onYearSelectedSecondary($event, datePickerHighSchool)
                    "
                  >
                  </mat-datepicker>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Taon na Dumalo</mat-hint
                >
              </div>
              <mat-label class="label"
                >Are you part of the K-12 curriculum?</mat-label
              >
              <div class="col-lg-12 mb-2">
                <mat-radio-group
                  formControlName="isAttendedSeniorHigh"
                  (change)="onk12RadioButtonsSelect()"
                >
                  <mat-radio-button [value]="true" class="radio-buttons-left"
                    >Yes
                  </mat-radio-button>
                  <mat-radio-button [value]="false" class="radio-buttons-right"
                    >No</mat-radio-button
                  >
                </mat-radio-group>
                <mat-error class="mt-2" *ngIf="showMessagek12 == true">{{
                  errorMessagek12
                }}</mat-error>
              </div>
              <div
                class="col-lg-6"
                *ngIf="
                  this.viewEducationalDetailsGroup.controls.isAttendedSeniorHigh
                    .value == true
                "
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>School Name</mat-label>
                  <input
                    matInput
                    formControlName="seniorHighSchool"
                    appNoLeadingSpaces
                  />
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Pangalan ng Paaralan</mat-hint
                >
              </div>
              <div
                class="col-lg-6"
                *ngIf="
                  this.viewEducationalDetailsGroup.controls.isAttendedSeniorHigh
                    .value == true
                "
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Senior High Strand</mat-label>
                  <mat-select formControlName="seniorHighSchoolStrands">
                    <mat-option
                      *ngFor="let strand of k12Strands"
                      [value]="strand.name"
                    >
                      {{ strand.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Strand</mat-hint
                >
              </div>
              <div
                class="col-lg-6"
                *ngIf="
                  this.viewEducationalDetailsGroup.controls.isAttendedSeniorHigh
                    .value == true
                "
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Level Reached</mat-label>
                  <mat-select formControlName="seniorHighSchoolLevelReached">
                    <mat-option
                      *ngFor="let k12Level of k12Levels"
                      [value]="k12Level.name"
                    >
                      {{ k12Level.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Naabot ang Antas</mat-hint
                >
              </div>
              <div
                class="col-lg-6"
                *ngIf="
                  this.viewEducationalDetailsGroup.controls.isAttendedSeniorHigh
                    .value == true
                "
              >
                <mat-form-field appearance="outline">
                  <mat-label>Year Attended</mat-label>
                  <input
                    matInput
                    placeholder="YYYY"
                    [matDatepicker]="datePickerHighk12"
                    formControlName="seniorHighSchoolYearAttended"
                    appNoLeadingSpaces
                    (focus)="datePickerHighk12?.open()"
                    readonly="true"
                    [min]="
                      educationalBackgroundDetailsGroup.get(
                        'highSchoolYearAttended'
                      ).value
                    "
                    [max]="maxDate"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="datePickerHighk12"
                  ></mat-datepicker-toggle>
                  <mat-datepicker
                    #datePickerHighk12
                    color="primary"
                    startView="multi-year"
                    (yearSelected)="
                      onYearSelectedK12($event, datePickerHighk12)
                    "
                    [startAt]="currentDate"
                  >
                  </mat-datepicker>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Taon na Dumalo</mat-hint
                >
              </div>
              <!-- Table Undergraduate : EducationLevel = 3 -->
              <mat-label class="label mb-2">Undergraduate Studies</mat-label>
              <div class="col-lg-12">
                <table
                  mat-table
                  [dataSource]="dataSourceUndergraduate"
                  class="table-responsive mb-3"
                  style="border: 1px solid #00943a; width: 100%"
                  #UndergraduateTable
                >
                  <!-- School Column -->
                  <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef [hidden]="true">
                      ID
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-column"
                      [hidden]="true"
                    >
                      {{ element.id }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="school">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      School
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-cell text-center"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                    >
                      {{ element.school }}
                    </td>
                  </ng-container>
                  <!-- Course Column -->
                  <ng-container matColumnDef="course">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      Course
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                      class="text-center"
                    >
                      {{ element.course }}
                    </td>
                  </ng-container>

                  <!-- Year Attended -->
                  <ng-container matColumnDef="yearAttended">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      Year Attended
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-cell text-center"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                    >
                      {{ element.yearAttended | date : "yyyy" }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="actions">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      class="text-center"
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                    ></th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                      class="table-cell"
                    >
                      <div class="d-flex justify-content-end">
                        <div class="row">
                          <div class="col-lg-12">
                            <!-- <mat-icon
                              (click)="updateUndergraduate(element)"
                              style="margin-right: 0.3rem"
                              >edit</mat-icon
                            >
                            <mat-icon (click)="deleteItemUndergraduate(element)"
                              >delete</mat-icon
                            > -->
                          </div>
                        </div>
                      </div>
                    </td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumnsUndergraduate"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumnsUndergraduate"
                  ></tr>
                  <!-- Add Item table row -->
                </table>
              </div>
            </div>
            <!-- Graduate Level -->
            <div class="row" *ngIf="highesEducationAttainment == 4">
              <mat-label class="label"> Elementary </mat-label>
              <mat-hint class="filipino-translation-hint">Elementarya</mat-hint>
              <div class="col-lg-8">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>School Name</mat-label>
                  <input
                    matInput
                    formControlName="elementarySchool"
                    appNoLeadingSpaces
                  />
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Pangalan ng Paaralan</mat-hint
                >
              </div>
              <div class="col-lg-4">
                <mat-form-field appearance="outline">
                  <mat-label>Year Attended</mat-label>
                  <mat-select
                    formControlName="elementaryYearAttended"
                    [(ngModel)]="elementaryYear"
                    (selectionChange)="checkYearElementary()"
                  >
                    <div class="year-calendar">
                      <mat-option
                        *ngFor="let year of displayedYears"
                        [value]="year"
                        class="year-option"
                        >{{ year }}</mat-option
                      >
                    </div>
                    <div class="pagination">
                      <button
                        mat-icon-button
                        (click)="prevPage()"
                        [disabled]="currentPage === 0"
                      >
                        <mat-icon>chevron_left</mat-icon>
                      </button>
                      <span style="padding: 0.5rem"
                        >{{ currentPage + 1 }} / {{ totalPages }}</span
                      >
                      <button
                        mat-icon-button
                        (click)="nextPage()"
                        [disabled]="currentPage === totalPages - 1"
                      >
                        <mat-icon>chevron_right</mat-icon>
                      </button>
                    </div>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Taon na Dumalo</mat-hint
                >
                <br />
                <mat-error *ngIf="errorMessageElementary">{{
                  errorMessageElementary
                }}</mat-error>
              </div>
              <mat-label class="label"> Secondary </mat-label>
              <mat-hint class="filipino-translation-hint"
                >Pangalawang lebel (High School/Senior High
                School/K-12)</mat-hint
              >
              <div class="col-lg-8">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>School Name</mat-label>
                  <input
                    matInput
                    formControlName="highSchool"
                    appNoLeadingSpaces
                  />
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Pangalan ng Paaralan</mat-hint
                >
              </div>
              <div class="col-lg-4">
                <mat-form-field appearance="outline">
                  <mat-label>Year Attended</mat-label>
                  <input
                    matInput
                    placeholder="YYYY"
                    [matDatepicker]="datePickerHighSchool"
                    formControlName="highSchoolYearAttended"
                    appNoLeadingSpaces
                    (focus)="datePicker?.open()"
                    readonly="true"
                    [min]="
                      educationalBackgroundDetailsGroup.get(
                        'elementaryYearAttended'
                      ).value
                    "
                    [max]="maxDate"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="datePickerHighSchool"
                  ></mat-datepicker-toggle>
                  <mat-datepicker
                    #datePickerHighSchool
                    color="primary"
                    startView="multi-year"
                    (yearSelected)="
                      onYearSelectedSecondary($event, datePickerHighSchool)
                    "
                    [startAt]="currentDate"
                  >
                  </mat-datepicker>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Taon na Dumalo</mat-hint
                >
              </div>
              <mat-label class="label"
                >Are you part of the K-12 curriculum?</mat-label
              >
              <div class="col-lg-12 mb-2">
                <mat-radio-group
                  formControlName="isAttendedSeniorHigh"
                  (change)="onk12RadioButtonsSelect()"
                >
                  <mat-radio-button [value]="true" class="radio-buttons-left"
                    >Yes
                  </mat-radio-button>
                  <mat-radio-button [value]="false" class="radio-buttons-right"
                    >No</mat-radio-button
                  >
                </mat-radio-group>
                <mat-error class="mt-2" *ngIf="showMessagek12 == true">{{
                  errorMessagek12
                }}</mat-error>
                <div
                  *ngIf="
                    educationalBackgroundDetailsGroup.get(
                      'isAttendedSeniorHigh'
                    ).touched &&
                    educationalBackgroundDetailsGroup
                      .get('isAttendedSeniorHigh')
                      .hasError('required')
                  "
                >
                  <div>
                    <span class="text text-danger"
                      >Please select an option.</span
                    >
                  </div>
                </div>
              </div>
              <div
                class="col-lg-6"
                *ngIf="
                  this.viewEducationalDetailsGroup.controls.isAttendedSeniorHigh
                    .value == true
                "
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>School Name</mat-label>
                  <input matInput formControlName="seniorHighSchool" />
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Pangalan ng Paaralan</mat-hint
                >
              </div>
              <div
                class="col-lg-6"
                *ngIf="
                  this.viewEducationalDetailsGroup.controls.isAttendedSeniorHigh
                    .value == true
                "
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Senior High Strand</mat-label>
                  <mat-select
                    formControlName="seniorHighSchoolStrands"
                    appNoLeadingSpaces
                  >
                    <mat-option
                      *ngFor="let strand of k12Strands"
                      [value]="strand.name"
                    >
                      {{ strand.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Strand</mat-hint
                >
              </div>
              <div
                class="col-lg-6"
                *ngIf="
                  this.viewEducationalDetailsGroup.controls.isAttendedSeniorHigh
                    .value == true
                "
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Level Reached</mat-label>
                  <mat-select formControlName="seniorHighSchoolLevelReached">
                    <mat-option
                      *ngFor="let k12Level of k12Levels"
                      [value]="k12Level.name"
                    >
                      {{ k12Level.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Naabot ang Antas</mat-hint
                >
              </div>
              <div
                class="col-lg-6"
                *ngIf="
                  this.viewEducationalDetailsGroup.controls.isAttendedSeniorHigh
                    .value == true
                "
              >
                <mat-form-field appearance="outline">
                  <mat-label>Year Attended</mat-label>
                  <input
                    matInput
                    placeholder="YYYY"
                    [matDatepicker]="datePickerHighk12"
                    formControlName="seniorHighSchoolYearAttended"
                    appNoLeadingSpaces
                    (focus)="datePickerHighk12?.open()"
                    readonly="true"
                    [min]="
                      educationalBackgroundDetailsGroup.get(
                        'highSchoolYearAttended'
                      ).value
                    "
                    [max]="maxDate"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="datePickerHighk12"
                  ></mat-datepicker-toggle>
                  <mat-datepicker
                    #datePickerHighk12
                    color="primary"
                    startView="multi-year"
                    (yearSelected)="
                      onYearSelectedK12($event, datePickerHighk12)
                    "
                    [startAt]="currentDate"
                  >
                  </mat-datepicker>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Taon na Dumalo</mat-hint
                >
              </div>
              <!-- Table Undergraduate : EducationLevel = 4 -->
              <mat-label class="label mb-2">Undergraduate Studies</mat-label>
              <div class="col-lg-12">
                <table
                  mat-table
                  [dataSource]="dataSourceUndergraduate"
                  class="table-responsive mb-3"
                  style="border: 1px solid #00943a; width: 100%"
                  #UndergraduateTable
                >
                  <!-- School Column -->
                  <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef [hidden]="true">
                      ID
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-column"
                      [hidden]="true"
                    >
                      {{ element.id }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="school">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      School
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-cell text-center"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                    >
                      {{ element.school }}
                    </td>
                  </ng-container>
                  <!-- Course Column -->
                  <ng-container matColumnDef="course">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      Course
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                      class="text-center"
                    >
                      {{ element.course }}
                    </td>
                  </ng-container>

                  <!-- Year Attended -->
                  <ng-container matColumnDef="yearAttended">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      Year Attended
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-cell text-center"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                    >
                      {{ element.yearAttended | date : "yyyy" }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="actions">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      class="text-center"
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                    ></th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                      class="table-cell"
                    >
                      <div class="d-flex justify-content-end">
                        <div class="row">
                          <div class="col-lg-12">
                            <!-- <mat-icon
                              (click)="updateUndergraduate(element)"
                              style="margin-right: 0.3rem"
                              >edit</mat-icon
                            >
                            <mat-icon (click)="deleteItemUndergraduate(element)"
                              >delete</mat-icon
                            > -->
                          </div>
                        </div>
                      </div>
                    </td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumnsUndergraduate"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumnsUndergraduate"
                  ></tr>
                  <!-- Add Item table row -->
                </table>
              </div>
              <!-- Table Graduate : EducationLevel = 4 -->
              <mat-label class="label mb-2">Graduate Studies</mat-label>
              <div class="col-lg-12">
                <table
                  mat-table
                  [dataSource]="dataSourceGraduate"
                  class="table-responsive mb-3"
                  style="border: 1px solid #00943a; width: 100%"
                  #graduateTable
                >
                  <!-- ID -->
                  <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef [hidden]="true">
                      ID
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-column"
                      [hidden]="true"
                    >
                      {{ element.id }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="school">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      School
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-cell text-center"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                    >
                      {{ element.school }}
                    </td>
                  </ng-container>

                  <!-- Program -->
                  <ng-container matColumnDef="program">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      Program
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                      class="text-center"
                    >
                      {{ element.program }}
                    </td>
                  </ng-container>

                  <!-- Major -->
                  <ng-container matColumnDef="major">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      Major
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-cell text-center"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                    >
                      {{ element.major }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="fieldOfStudy">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      Field of Study
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-cell text-center"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                    >
                      {{ element.fieldOfStudy }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="course">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      Thesis Title
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-cell text-center"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                    >
                      {{ element.thesisTitle }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="yearAttended">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      Year Attended
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-cell text-center"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                    >
                      {{ element.yearAttended | date : "yyyy" }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="actions">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      class="text-center"
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                    ></th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                      class="table-cell"
                    >
                      <div class="d-flex justify-content-end">
                        <div class="row">
                          <div class="col-lg-12">
                            <!-- <mat-icon
                              (click)="updateGraduate(element)"
                              style="margin-right: 0.3rem"
                              >edit</mat-icon
                            >
                            <mat-icon (click)="deleteItemGraduate(element)"
                              >delete</mat-icon
                            > -->
                          </div>
                        </div>
                      </div>
                    </td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumnsGraduate"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumnsGraduate"
                  ></tr>
                  <!-- Add Item table row -->
                </table>
              </div>
            </div>
            <!-- Post Graduate Level -->
            <div class="row" *ngIf="highesEducationAttainment == 5">
              <mat-label class="label"> Elementary </mat-label>
              <mat-hint class="filipino-translation-hint">Elementarya</mat-hint>
              <div class="col-lg-8">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>School Name</mat-label>
                  <input
                    matInput
                    formControlName="elementarySchool"
                    appNoLeadingSpaces
                  />
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Pangalan ng Paaralan</mat-hint
                >
              </div>
              <div class="col-lg-4">
                <mat-form-field appearance="outline">
                  <mat-label>Year Attended</mat-label>
                  <input
                    matInput
                    placeholder="YYYY"
                    [matDatepicker]="datePicker"
                    formControlName="elementaryYearAttended"
                    appNoLeadingSpaces
                    (focus)="datePicker?.open()"
                    readonly="true"
                    [min]="minDate"
                    [max]="maxDate"
                    [startAt]="currentDate"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="datePicker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker
                    #datePicker
                    color="primary"
                    startView="multi-year"
                    (yearSelected)="
                      onYearSelectedElementary($event, datePicker)
                    "
                  ></mat-datepicker>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Taong Dumalo</mat-hint
                >
              </div>
              <mat-label class="label">Secondary</mat-label>
              <mat-hint class="filipino-translation-hint"
                >Pangalawang lebel (High School/Senior High
                School/K-12)</mat-hint
              >
              <div class="col-lg-8">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>School Name</mat-label>
                  <input
                    matInput
                    formControlName="highSchool"
                    appNoLeadingSpaces
                  />
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Pangalan ng Paaralan</mat-hint
                >
              </div>
              <div class="col-lg-4">
                <mat-form-field appearance="outline">
                  <mat-label>Year Attended</mat-label>
                  <input
                    matInput
                    placeholder="YYYY"
                    [matDatepicker]="datePickerHighSchool"
                    formControlName="highSchoolYearAttended"
                    appNoLeadingSpaces
                    (focus)="datePicker?.open()"
                    readonly="true"
                    [min]="
                      educationalBackgroundDetailsGroup.get(
                        'elementaryYearAttended'
                      ).value
                    "
                    [max]="maxDate"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="datePickerHighSchool"
                  ></mat-datepicker-toggle>
                  <mat-datepicker
                    #datePickerHighSchool
                    color="primary"
                    startView="multi-year"
                    (yearSelected)="
                      onYearSelectedSecondary($event, datePickerHighSchool)
                    "
                    [startAt]="currentDate"
                  >
                  </mat-datepicker>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Taong Dumalo</mat-hint
                >
              </div>
              <mat-label class="label"
                >Are you part of the K-12 curriculum?</mat-label
              >
              <div class="col-lg-12 mb-2">
                <mat-radio-group
                  formControlName="isAttendedSeniorHigh"
                  (change)="onk12RadioButtonsSelect()"
                >
                  <mat-radio-button [value]="true" class="radio-buttons-left"
                    >Yes
                  </mat-radio-button>
                  <mat-radio-button [value]="false" class="radio-buttons-right"
                    >No</mat-radio-button
                  >
                </mat-radio-group>
                <mat-error class="mt-2" *ngIf="showMessagek12 == true">{{
                  errorMessagek12
                }}</mat-error>
              </div>
              <div
                class="col-lg-6"
                *ngIf="
                  this.viewEducationalDetailsGroup.controls.isAttendedSeniorHigh
                    .value == true
                "
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>School Name</mat-label>
                  <input
                    matInput
                    formControlName="seniorHighSchool"
                    appNoLeadingSpaces
                  />
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Pangalan ng Paaralan</mat-hint
                >
              </div>
              <div
                class="col-lg-6"
                *ngIf="
                  this.viewEducationalDetailsGroup.controls.isAttendedSeniorHigh
                    .value == true
                "
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Senior High Strand</mat-label>
                  <mat-select formControlName="seniorHighSchoolStrands">
                    <mat-option
                      *ngFor="let strand of k12Strands"
                      [value]="strand.name"
                    >
                      {{ strand.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Strand</mat-hint
                >
              </div>
              <div
                class="col-lg-6"
                *ngIf="
                  this.viewEducationalDetailsGroup.controls.isAttendedSeniorHigh
                    .value == true
                "
              >
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Level Reached</mat-label>
                  <mat-select formControlName="seniorHighSchoolLevelReached">
                    <mat-option
                      *ngFor="let k12Level of k12Levels"
                      [value]="k12Level.name"
                    >
                      {{ k12Level.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Naabot ang Antas</mat-hint
                >
              </div>
              <div
                class="col-lg-6"
                *ngIf="
                  this.viewEducationalDetailsGroup.controls.isAttendedSeniorHigh
                    .value == true
                "
              >
                <mat-form-field appearance="outline">
                  <mat-label>Year Attended</mat-label>
                  <input
                    matInput
                    placeholder="YYYY"
                    [matDatepicker]="datePickerHighk12"
                    formControlName="seniorHighSchoolYearAttended"
                    appNoLeadingSpaces
                    (focus)="datePickerHighk12?.open()"
                    readonly="true"
                    [min]="
                      educationalBackgroundDetailsGroup.get(
                        'highSchoolYearAttended'
                      ).value
                    "
                    [max]="maxDate"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="datePickerHighk12"
                  ></mat-datepicker-toggle>
                  <mat-datepicker
                    #datePickerHighk12
                    color="primary"
                    startView="multi-year"
                    (yearSelected)="
                      onYearSelectedK12($event, datePickerHighk12)
                    "
                    [startAt]="currentDate"
                  >
                  </mat-datepicker>
                </mat-form-field>
                <mat-hint class="filipino-translation-hint mb-2"
                  >Taon na Dumalo</mat-hint
                >
              </div>
              <!-- Multiple Undergraduate Studies : educationLevel = 5-->
              <mat-label class="label mb-2">Undergraduate Studies</mat-label>
              <div class="col-lg-12">
                <table
                  mat-table
                  [dataSource]="dataSourceUndergraduate"
                  class="table-responsive mb-3"
                  style="border: 1px solid #00943a; width: 100%"
                  #UndergraduateTable
                >
                  <!-- School Column -->
                  <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef [hidden]="true">
                      ID
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-column"
                      [hidden]="true"
                    >
                      {{ element.id }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="school">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      School
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-cell text-center"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                    >
                      {{ element.school }}
                    </td>
                  </ng-container>
                  <!-- Course Column -->
                  <ng-container matColumnDef="course">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      Course
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                      class="text-center"
                    >
                      {{ element.course }}
                    </td>
                  </ng-container>

                  <!-- Year Attended -->
                  <ng-container matColumnDef="yearAttended">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      Year Attended
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-cell text-center"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                    >
                      {{ element.yearAttended | date : "yyyy" }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="actions">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      class="text-center"
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                    ></th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                      class="table-cell"
                    >
                      <div class="d-flex justify-content-end">
                        <div class="row">
                          <div class="col-lg-12">
                            <!-- <mat-icon
                              (click)="updateUndergraduate(element)"
                              style="margin-right: 0.3rem"
                              >edit</mat-icon
                            >
                            <mat-icon (click)="deleteItemUndergraduate(element)"
                              >delete</mat-icon
                            > -->
                          </div>
                        </div>
                      </div>
                    </td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumnsUndergraduate"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumnsUndergraduate"
                  ></tr>
                  <!-- Add Item table row -->
                </table>
              </div>
              <!-- Multiple Graduate Studies : educationLevel = 5 -->
              <mat-label class="label mb-2">Graduate Studies</mat-label>
              <div class="col-lg-12">
                <table
                  mat-table
                  [dataSource]="dataSourceGraduate"
                  class="table-responsive mb-3"
                  style="border: 1px solid #00943a; width: 100%"
                  #graduateTable
                >
                  <!-- ID -->
                  <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef [hidden]="true">
                      ID
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-column"
                      [hidden]="true"
                    >
                      {{ element.id }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="school">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      School
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-cell text-center"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                    >
                      {{ element.school }}
                    </td>
                  </ng-container>

                  <!-- Program -->
                  <ng-container matColumnDef="program">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      Program
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                      class="text-center"
                    >
                      {{ element.program }}
                    </td>
                  </ng-container>

                  <!-- Major -->
                  <ng-container matColumnDef="major">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      Major
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-cell text-center"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                    >
                      {{ element.major }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="fieldOfStudy">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      Field of Study
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-cell text-center"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                    >
                      {{ element.fieldOfStudy }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="course">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      Thesis Title
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-cell text-center"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                    >
                      {{ element.thesisTitle }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="yearAttended">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      Year Attended
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-cell text-center"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                    >
                      {{ element.yearAttended | date : "yyyy" }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="actions">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      class="text-center"
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                    ></th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                      class="table-cell"
                    >
                      <div class="d-flex justify-content-end">
                        <div class="row">
                          <div class="col-lg-12">
                            <!-- <mat-icon
                              (click)="updateGraduate(element)"
                              style="margin-right: 0.3rem"
                              >edit</mat-icon
                            >
                            <mat-icon (click)="deleteItemGraduate(element)"
                              >delete</mat-icon
                            > -->
                          </div>
                        </div>
                      </div>
                    </td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumnsGraduate"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumnsGraduate"
                  ></tr>
                  <!-- Add Item table row -->
                </table>
              </div>
              <!-- Table Post Graduate -->
              <mat-label class="label mb-2">Post Graduate Studies</mat-label>
              <div class="col-lg-12">
                <table
                  mat-table
                  [dataSource]="dataSourcePostGraduate"
                  class="table-responsive mb-3"
                  style="border: 1px solid #00943a"
                  #postGraduateTable
                  [style.width.%]="100"
                >
                  <!-- ID -->
                  <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef [hidden]="true">
                      ID
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-column"
                      [hidden]="true"
                    >
                      {{ element.id }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="school">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      School
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-cell text-center"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                    >
                      {{ element.school }}
                    </td>
                  </ng-container>

                  <!-- Program -->
                  <ng-container matColumnDef="program">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      Program
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                      class="text-center"
                    >
                      {{ element.program }}
                    </td>
                  </ng-container>
                  <!-- Major -->
                  <ng-container matColumnDef="major">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      Major
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-cell text-center"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                    >
                      {{ element.major }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="dissertationTitle">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      Dissertation Title
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-cell text-center"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                    >
                      {{ element.dissertationTitle }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="fieldOfStudy">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      Field of Study
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-cell text-center"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                    >
                      {{ element.fieldOfStudy }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="researchInterest">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      Research of Interest
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-cell text-center"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                    >
                      {{ element.researchInterests }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="publications">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      Publications
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-cell text-center"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                    >
                      {{ element.publications }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="yearAttended">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                      class="text-center"
                    >
                      Year Attended
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="table-cell text-center"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                    >
                      {{ element.yearAttended | date : "yyyy" }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="actions">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      class="text-center"
                      style="
                        padding: 1rem;
                        border-bottom: 1px solid #00943a;
                        background-color: #00943a;
                        color: #ffffff;
                        font-size: 14px;
                      "
                    ></th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      style="padding: 1rem; border-bottom: 1px solid #00943a"
                      class="table-cell"
                    >
                      <div class="d-flex justify-content-end">
                        <div class="row">
                          <div class="col-lg-12">
                            <!-- <mat-icon
                              (click)="updatePostGraduate(element)"
                              style="margin-right: 0.3rem"
                              >edit</mat-icon
                            >
                            <mat-icon (click)="deletePostItemGraduate(element)"
                              >delete</mat-icon
                            > -->
                          </div>
                        </div>
                      </div>
                    </td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumnsPostGraduate"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumnsPostGraduate"
                  ></tr>
                  <!-- Add Item table row -->
                </table>
              </div>
            </div>
          </form>
        </div>
      </ng-template>
      <!-- Edit Mode Educational-->
      <div *ngIf="isEducationalDetailsEditMode; else viewEducational">
        <form [formGroup]="educationalBackgroundDetailsGroup">
          <div class="row">
            <mat-label class="label">Are you still studying?</mat-label>
            <mat-hint class="filipino-translation-hint mb-2"
              >Nag-aaral ka pa ba?</mat-hint
            >
            <mat-radio-group
              formControlName="isStillStudying"
              [(ngModel)]="selectedIsStillStudying"
              (selectionChange)="onEducationStatusChange()"
            >
              <mat-radio-button [value]="true" class="radio-buttons-left"
                >Yes
              </mat-radio-button>
              <mat-radio-button [value]="false" class="radio-buttons-right"
                >No</mat-radio-button
              >
            </mat-radio-group>
          </div>
          <div
            class="row mt-2 mb-2"
            *ngIf="
              selectedIsStillStudying == true ||
              selectedIsStillStudying == false
            "
          >
            <mat-label class="label mb-2">
              Highest educational attainment?
            </mat-label>
            <mat-hint class="filipino-translation-hint mb-2"
              >Ano ang iyong pinakamataas na background sa edukasyon?
            </mat-hint>
            <mat-form-field appearance="outline" [style.width.%]="100">
              <mat-label>Educational Attainment</mat-label>
              <mat-select
                [(ngModel)]="highesEducationAttainment"
                formControlName="highestEducationLevel"
                (selectionChange)="onEducationStatusChange()"
              >
                <mat-option [value]="0">No Formal Education</mat-option>
                <mat-option [value]="1">Elementary Level</mat-option>
                <mat-option [value]="2">Secondary Level</mat-option>
                <mat-option [value]="3"
                  >Undergraduate Level (Bachelor's Degree)</mat-option
                >
                <mat-option [value]="4"
                  >Graduate Level (Master's Degree)</mat-option
                >
                <mat-option [value]="5"
                  >Post Graduate Level (Doctorate Degree)</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
          <!-- Elementary Level -->
          <div class="row" *ngIf="highesEducationAttainment == 1">
            <mat-label class="label"> Elementary </mat-label>
            <mat-hint class="filipino-translation-hint">Elementarya</mat-hint>
            <div class="col-lg-4">
              <mat-form-field appearance="outline" [style.width.%]="100">
                <mat-label>School Name</mat-label>
                <input
                  matInput
                  formControlName="elementarySchool"
                  appNoLeadingSpaces
                />
              </mat-form-field>
              <mat-hint class="filipino-translation-hint mb-2"
                >Pangalan ng Paaralan</mat-hint
              >
            </div>
            <div class="col-lg-4">
              <mat-form-field appearance="outline" [style.width.%]="100">
                <mat-label>Level Reached</mat-label>
                <mat-select formControlName="elementaryLevelReached">
                  <mat-option
                    *ngFor="let elementaryLevel of elementaryLevels"
                    [value]="elementaryLevel.name"
                  >
                    {{ elementaryLevel.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-hint class="filipino-translation-hint mb-2"
                >Naabot ang Antas</mat-hint
              >
            </div>
            <div class="col-lg-4">
              <mat-form-field appearance="outline">
                <mat-label>Year Attended</mat-label>
                <input
                  matInput
                  placeholder="YYYY"
                  [matDatepicker]="datePicker"
                  formControlName="elementaryYearAttended"
                  appNoLeadingSpaces
                  (focus)="datePicker?.open()"
                  readonly="true"
                  [min]="minDate"
                  [max]="maxDate"
                  [startAt]="currentDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="datePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #datePicker
                  color="primary"
                  startView="multi-year"
                  (yearSelected)="onYearSelectedElementary($event, datePicker)"
                ></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <!-- Secondary  -->
          <div class="row" *ngIf="highesEducationAttainment == 2">
            <mat-label class="label"> Elementary </mat-label>
            <mat-hint class="filipino-translation-hint">Elementarya</mat-hint>
            <div class="col-lg-8">
              <mat-form-field appearance="outline" [style.width.%]="100">
                <mat-label>School Name</mat-label>
                <input
                  matInput
                  formControlName="elementarySchool"
                  appNoLeadingSpaces
                />
              </mat-form-field>
              <mat-hint class="filipino-translation-hint mb-2"
                >Pangalan ng Paaralan</mat-hint
              >
            </div>
            <div class="col-lg-4">
              <mat-form-field appearance="outline">
                <mat-label>Year Attended</mat-label>
                <input
                  matInput
                  placeholder="YYYY"
                  [matDatepicker]="datePicker"
                  formControlName="elementaryYearAttended"
                  appNoLeadingSpaces
                  (focus)="datePicker?.open()"
                  readonly="true"
                  [min]="minDate"
                  [max]="maxDate"
                  [startAt]="currentDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="datePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #datePicker
                  color="primary"
                  startView="multi-year"
                  (yearSelected)="onYearSelectedElementary($event, datePicker)"
                ></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="contianer">
              <mat-label class="label">Secondary</mat-label>
              <div class="row">
                <div class="col-lg-4">
                  <mat-form-field appearance="outline" [style.width.%]="100">
                    <mat-label>School Name</mat-label>
                    <input
                      matInput
                      formControlName="highSchool"
                      appNoLeadingSpaces
                    />
                  </mat-form-field>
                  <mat-hint class="filipino-translation-hint mb-2"
                    >Pangalan ng Paaralan</mat-hint
                  >
                </div>
                <div class="col-lg-4">
                  <mat-form-field appearance="outline" [style.width.%]="100">
                    <mat-label>Level Reached</mat-label>
                    <mat-select formControlName="highSchoolLevelReached">
                      <mat-option
                        *ngFor="let secondaryLevel of secondaryLevels"
                        [value]="secondaryLevel.name"
                      >
                        {{ secondaryLevel.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-hint class="filipino-translation-hint mb-2"
                    >Naabot ang Antas</mat-hint
                  >
                </div>
                <div class="col-lg-4">
                  <mat-form-field appearance="outline">
                    <mat-label>Year Attended</mat-label>
                    <input
                      matInput
                      placeholder="YYYY"
                      [matDatepicker]="datePickerHighSchool"
                      formControlName="highSchoolYearAttended"
                      appNoLeadingSpaces
                      (focus)="datePicker?.open()"
                      readonly="true"
                      [min]="
                        educationalBackgroundDetailsGroup.get(
                          'elementaryYearAttended'
                        ).value
                      "
                      [max]="maxDate"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="datePickerHighSchool"
                    ></mat-datepicker-toggle>
                    <mat-datepicker
                      #datePickerHighSchool
                      color="primary"
                      startView="multi-year"
                      (yearSelected)="
                        onYearSelectedSecondary($event, datePickerHighSchool)
                      "
                      [startAt]="currentDate"
                    >
                    </mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <mat-label class="label">
              Are you part of the K-12 curriculum?
            </mat-label>
            <mat-radio-group
              formControlName="isAttendedSeniorHigh"
              (change)="onk12RadioButtonsSelect()"
              class="mb-2"
            >
              <mat-radio-button [value]="true" class="radio-buttons-left"
                >Yes
              </mat-radio-button>
              <mat-radio-button [value]="false" class="radio-buttons-right"
                >No</mat-radio-button
              >
            </mat-radio-group>
            <!-- <mat-error class="mt-2" *ngIf="errorMessagek12">{{
                errorMessagek12
              }}</mat-error> -->
            <div
              class="col-lg-6"
              *ngIf="
                this.educationalBackgroundDetailsGroup.controls
                  .isAttendedSeniorHigh.value == true
              "
            >
              <mat-form-field appearance="outline" [style.width.%]="100">
                <mat-label>School Name</mat-label>
                <input
                  matInput
                  formControlName="seniorHighSchool"
                  appNoLeadingSpaces
                />
              </mat-form-field>
              <mat-hint class="filipino-translation-hint mb-2"
                >Pangalan ng Paaralan</mat-hint
              >
            </div>
            <div
              class="col-lg-6"
              *ngIf="
                this.educationalBackgroundDetailsGroup.controls
                  .isAttendedSeniorHigh.value == true
              "
            >
              <mat-form-field appearance="outline" [style.width.%]="100">
                <mat-label>Senior High Strand</mat-label>
                <mat-select formControlName="seniorHighSchoolStrands">
                  <mat-option
                    *ngFor="let strand of k12Strands"
                    [value]="strand.name"
                  >
                    {{ strand.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-hint class="filipino-translation-hint mb-2">Strand</mat-hint>
            </div>
            <div
              class="col-lg-6"
              *ngIf="
                this.educationalBackgroundDetailsGroup.controls
                  .isAttendedSeniorHigh.value == true
              "
            >
              <mat-form-field appearance="outline" [style.width.%]="100">
                <mat-label>Level Reached</mat-label>
                <mat-select formControlName="seniorHighSchoolLevelReached">
                  <mat-option
                    *ngFor="let k12Level of k12Levels"
                    [value]="k12Level.name"
                  >
                    {{ k12Level.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-hint class="filipino-translation-hint mb-2"
                >Naabot ang Antas</mat-hint
              >
            </div>
            <div
              class="col-lg-6"
              *ngIf="
                this.educationalBackgroundDetailsGroup.controls
                  .isAttendedSeniorHigh.value == true
              "
            >
              <mat-form-field appearance="outline">
                <mat-label>Year Attended</mat-label>
                <input
                  matInput
                  placeholder="YYYY"
                  [matDatepicker]="datePickerHighk12"
                  formControlName="seniorHighSchoolYearAttended"
                  appNoLeadingSpaces
                  (focus)="datePickerHighk12?.open()"
                  readonly="true"
                  [min]="
                    educationalBackgroundDetailsGroup.get(
                      'highSchoolYearAttended'
                    ).value
                  "
                  [max]="maxDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="datePickerHighk12"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #datePickerHighk12
                  color="primary"
                  startView="multi-year"
                  (yearSelected)="onYearSelectedK12($event, datePickerHighk12)"
                  [startAt]="currentDate"
                >
                </mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <!-- Undergraduate  -->
          <div class="row" *ngIf="highesEducationAttainment == 3">
            <mat-label class="label"> Elementary </mat-label>
            <mat-hint class="filipino-translation-hint">Elementarya</mat-hint>
            <div class="col-lg-8">
              <mat-form-field appearance="outline" [style.width.%]="100">
                <mat-label>School Name</mat-label>
                <input
                  matInput
                  formControlName="elementarySchool"
                  appNoLeadingSpaces
                />
              </mat-form-field>
              <mat-hint class="filipino-translation-hint mb-2"
                >Pangalan ng Paaralan</mat-hint
              >
            </div>
            <div class="col-lg-4">
              <mat-form-field appearance="outline">
                <mat-label>Year Attended</mat-label>
                <input
                  matInput
                  placeholder="YYYY"
                  [matDatepicker]="datePicker"
                  formControlName="elementaryYearAttended"
                  appNoLeadingSpaces
                  (focus)="datePicker?.open()"
                  readonly="true"
                  [max]="maxDate"
                  [startAt]="currentDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="datePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #datePicker
                  color="primary"
                  startView="multi-year"
                  (yearSelected)="onYearSelectedElementary($event, datePicker)"
                ></mat-datepicker>
              </mat-form-field>
            </div>
            <mat-label class="label">Secondary</mat-label>
            <mat-hint class="filipino-translation-hint"
              >Pangalawang lebel (High School/Senior High School/K-12)</mat-hint
            >
            <div class="col-lg-8">
              <mat-form-field appearance="outline" [style.width.%]="100">
                <mat-label>School Name</mat-label>
                <input
                  matInput
                  formControlName="highSchool"
                  appNoLeadingSpaces
                />
              </mat-form-field>
              <mat-hint class="filipino-translation-hint mb-2"
                >Pangalan ng Paaralan</mat-hint
              >
            </div>
            <div class="col-lg-4">
              <mat-form-field appearance="outline">
                <mat-label>Year Attended</mat-label>
                <input
                  matInput
                  placeholder="YYYY"
                  [matDatepicker]="datePickerHighSchool"
                  formControlName="highSchoolYearAttended"
                  appNoLeadingSpaces
                  (focus)="datePicker?.open()"
                  readonly="true"
                  [min]="
                    educationalBackgroundDetailsGroup.get(
                      'elementaryYearAttended'
                    ).value
                  "
                  [max]="maxDate"
                  [startAt]="currentDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="datePickerHighSchool"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #datePickerHighSchool
                  color="primary"
                  startView="multi-year"
                  (yearSelected)="
                    onYearSelectedSecondary($event, datePickerHighSchool)
                  "
                >
                </mat-datepicker>
              </mat-form-field>
            </div>
            <mat-label class="label"
              >Are you part of the K-12 curriculum?</mat-label
            >
            <div class="col-lg-12 mb-2">
              <mat-radio-group
                formControlName="isAttendedSeniorHigh"
                (change)="onk12RadioButtonsSelect()"
              >
                <mat-radio-button [value]="true" class="radio-buttons-left"
                  >Yes
                </mat-radio-button>
                <mat-radio-button [value]="false" class="radio-buttons-right"
                  >No</mat-radio-button
                >
              </mat-radio-group>
              <!-- <mat-error class="mt-2" *ngIf="showMessagek12 == true">{{
                    errorMessagek12
                  }}</mat-error> -->
            </div>
            <div
              class="col-lg-6"
              *ngIf="
                this.educationalBackgroundDetailsGroup.controls
                  .isAttendedSeniorHigh.value == true
              "
            >
              <mat-form-field appearance="outline" [style.width.%]="100">
                <mat-label>School Name</mat-label>
                <input
                  matInput
                  formControlName="seniorHighSchool"
                  appNoLeadingSpaces
                />
              </mat-form-field>
              <mat-hint class="filipino-translation-hint mb-2"
                >Pangalan ng Paaralan</mat-hint
              >
            </div>
            <div
              class="col-lg-6"
              *ngIf="
                this.educationalBackgroundDetailsGroup.controls
                  .isAttendedSeniorHigh.value == true
              "
            >
              <mat-form-field appearance="outline" [style.width.%]="100">
                <mat-label>Senior High Strand</mat-label>
                <mat-select formControlName="seniorHighSchoolStrands">
                  <mat-option
                    *ngFor="let strand of k12Strands"
                    [value]="strand.name"
                  >
                    {{ strand.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-hint class="filipino-translation-hint mb-2">Strand</mat-hint>
            </div>
            <div
              class="col-lg-6"
              *ngIf="
                this.educationalBackgroundDetailsGroup.controls
                  .isAttendedSeniorHigh.value == true
              "
            >
              <mat-form-field appearance="outline" [style.width.%]="100">
                <mat-label>Level Reached</mat-label>
                <mat-select formControlName="seniorHighSchoolLevelReached">
                  <mat-option
                    *ngFor="let k12Level of k12Levels"
                    [value]="k12Level.name"
                  >
                    {{ k12Level.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-hint class="filipino-translation-hint mb-2"
                >Naabot ang Antas</mat-hint
              >
            </div>
            <div
              class="col-lg-6"
              *ngIf="
                this.educationalBackgroundDetailsGroup.controls
                  .isAttendedSeniorHigh.value == true
              "
            >
              <mat-form-field appearance="outline">
                <mat-label>Year Attended</mat-label>
                <input
                  matInput
                  placeholder="YYYY"
                  [matDatepicker]="datePickerHighk12"
                  formControlName="seniorHighSchoolYearAttended"
                  appNoLeadingSpaces
                  (focus)="datePickerHighk12?.open()"
                  readonly="true"
                  [min]="
                    educationalBackgroundDetailsGroup.get(
                      'highSchoolYearAttended'
                    ).value
                  "
                  [max]="maxDate"
                  [startAt]="currentDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="datePickerHighk12"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #datePickerHighk12
                  color="primary"
                  startView="multi-year"
                  (yearSelected)="onYearSelectedK12($event, datePickerHighk12)"
                >
                </mat-datepicker>
              </mat-form-field>
            </div>
            <!-- Table Undergraduate : EducationLevel = 3 -->
            <mat-label class="label mb-2">Undergraduate Studies</mat-label>
            <div class="col-lg-12">
              <table
                mat-table
                [dataSource]="dataSourceUndergraduate"
                class="table-responsive mb-3"
                style="border: 1px solid #00943a"
                #UndergraduateTable
                [style.width.%]="100"
              >
                <!-- School Column -->
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef [hidden]="true">ID</th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-column"
                    [hidden]="true"
                  >
                    {{ element.id }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="school">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    School
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-cell text-center"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                  >
                    {{ element.school }}
                  </td>
                </ng-container>
                <!-- Course Column -->
                <ng-container matColumnDef="course">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    Course
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                    class="text-center"
                  >
                    {{ element.course }}
                  </td>
                </ng-container>

                <!-- Year Attended -->
                <ng-container matColumnDef="yearAttended">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    Year Attended
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-cell text-center"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                  >
                    {{ element.yearAttended | date : "yyyy" }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="text-center"
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                  ></th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                    class="table-cell"
                  >
                    <div class="d-flex justify-content-end">
                      <div class="row">
                        <div class="col-lg-12">
                          <mat-icon
                            (click)="updateUndergraduate(element)"
                            style="margin-right: 0.3rem"
                            >edit</mat-icon
                          >
                          <mat-icon (click)="deleteItemUndergraduate(element)"
                            >delete</mat-icon
                          >
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-container>
                <tr
                  mat-header-row
                  *matHeaderRowDef="displayedColumnsUndergraduate"
                ></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumnsUndergraduate"
                ></tr>
                <!-- Add Item table row -->
                <tr mat-footer-row *matFooterRowDef="['add-item']"></tr>
              </table>
            </div>
          </div>
          <!-- Graduate Studies -->
          <div class="row" *ngIf="highesEducationAttainment == 4">
            <mat-label class="label"> Elementary </mat-label>
            <mat-hint class="filipino-translation-hint">Elementarya</mat-hint>
            <div class="col-lg-8">
              <mat-form-field appearance="outline" [style.width.%]="100">
                <mat-label>School Name</mat-label>
                <input
                  matInput
                  formControlName="elementarySchool"
                  appNoLeadingSpaces
                />
              </mat-form-field>
              <mat-hint class="filipino-translation-hint mb-2"
                >Pangalan ng Paaralan</mat-hint
              >
            </div>
            <div class="col-lg-4">
              <mat-form-field appearance="outline">
                <mat-label>Year Attended</mat-label>
                <input
                  matInput
                  placeholder="YYYY"
                  [matDatepicker]="datePicker"
                  formControlName="elementaryYearAttended"
                  appNoLeadingSpaces
                  (focus)="datePicker?.open()"
                  readonly="true"
                  [minDate]="minDate"
                  [startAt]="currentDate"
                  [max]="maxDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="datePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #datePicker
                  color="primary"
                  startView="multi-year"
                  (yearSelected)="onYearSelectedElementary($event, datePicker)"
                ></mat-datepicker>
              </mat-form-field>
            </div>
            <mat-label class="label"> Secondary </mat-label>
            <mat-hint class="filipino-translation-hint"
              >Pangalawang lebel (High School/Senior High School/K-12)</mat-hint
            >
            <div class="col-lg-8">
              <mat-form-field appearance="outline" [style.width.%]="100">
                <mat-label>School Name</mat-label>
                <input
                  matInput
                  formControlName="highSchool"
                  appNoLeadingSpaces
                />
              </mat-form-field>
              <mat-hint class="filipino-translation-hint mb-2"
                >Pangalan ng Paaralan</mat-hint
              >
            </div>
            <div class="col-lg-4">
              <mat-form-field appearance="outline">
                <mat-label>Year Attended</mat-label>
                <input
                  matInput
                  placeholder="YYYY"
                  [matDatepicker]="datePickerHighSchool"
                  formControlName="highSchoolYearAttended"
                  appNoLeadingSpaces
                  (focus)="datePicker?.open()"
                  readonly="true"
                  [min]="
                    educationalBackgroundDetailsGroup.get(
                      'elementaryYearAttended'
                    ).value
                  "
                  [max]="maxDate"
                  [startAt]="currentDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="datePickerHighSchool"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #datePickerHighSchool
                  color="primary"
                  startView="multi-year"
                  (yearSelected)="
                    onYearSelectedSecondary($event, datePickerHighSchool)
                  "
                >
                </mat-datepicker>
              </mat-form-field>
            </div>
            <mat-label class="label"
              >Are you part of the K-12 curriculum?</mat-label
            >
            <div class="col-lg-12 mb-2">
              <mat-radio-group
                formControlName="isAttendedSeniorHigh"
                (change)="onk12RadioButtonsSelect()"
              >
                <mat-radio-button [value]="true" class="radio-buttons-left"
                  >Yes
                </mat-radio-button>
                <mat-radio-button [value]="false" class="radio-buttons-right"
                  >No</mat-radio-button
                >
              </mat-radio-group>
              <div
                *ngIf="
                  educationalBackgroundDetailsGroup.get('isAttendedSeniorHigh')
                    .touched &&
                  educationalBackgroundDetailsGroup
                    .get('isAttendedSeniorHigh')
                    .hasError('required')
                "
              >
                <div>
                  <span class="text text-danger">Please select an option.</span>
                </div>
              </div>
            </div>
            <div
              class="col-lg-6"
              *ngIf="
                this.educationalBackgroundDetailsGroup.controls
                  .isAttendedSeniorHigh.value == true
              "
            >
              <mat-form-field appearance="outline" [style.width.%]="100">
                <mat-label>School Name</mat-label>
                <input
                  matInput
                  formControlName="seniorHighSchool"
                  appNoLeadingSpaces
                />
              </mat-form-field>
              <mat-hint class="filipino-translation-hint mb-2"
                >Pangalan ng Paaralan</mat-hint
              >
            </div>
            <div
              class="col-lg-6"
              *ngIf="
                this.educationalBackgroundDetailsGroup.controls
                  .isAttendedSeniorHigh.value == true
              "
            >
              <mat-form-field appearance="outline" [style.width.%]="100">
                <mat-label>Senior High Strand</mat-label>
                <mat-select formControlName="seniorHighSchoolStrands">
                  <mat-option
                    *ngFor="let strand of k12Strands"
                    [value]="strand.name"
                  >
                    {{ strand.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-hint class="filipino-translation-hint mb-2">Strand</mat-hint>
            </div>
            <div
              class="col-lg-6"
              *ngIf="
                this.educationalBackgroundDetailsGroup.controls
                  .isAttendedSeniorHigh.value == true
              "
            >
              <mat-form-field appearance="outline" [style.width.%]="100">
                <mat-label>Level Reached</mat-label>
                <mat-select formControlName="seniorHighSchoolLevelReached">
                  <mat-option
                    *ngFor="let k12Level of k12Levels"
                    [value]="k12Level.name"
                  >
                    {{ k12Level.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-hint class="filipino-translation-hint mb-2"
                >Naabot ang Antas</mat-hint
              >
            </div>
            <div
              class="col-lg-6"
              *ngIf="
                this.educationalBackgroundDetailsGroup.controls
                  .isAttendedSeniorHigh.value == true
              "
            >
              <mat-form-field appearance="outline">
                <mat-label>Year Attended</mat-label>
                <input
                  matInput
                  placeholder="YYYY"
                  [matDatepicker]="datePickerHighk12"
                  formControlName="seniorHighSchoolYearAttended"
                  appNoLeadingSpaces
                  (focus)="datePickerHighk12?.open()"
                  readonly="true"
                  [min]="
                    educationalBackgroundDetailsGroup.get(
                      'highSchoolYearAttended'
                    ).value
                  "
                  [max]="maxDate"
                  [startAt]="currentDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="datePickerHighk12"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #datePickerHighk12
                  color="primary"
                  startView="multi-year"
                  (yearSelected)="onYearSelectedK12($event, datePickerHighk12)"
                >
                </mat-datepicker>
              </mat-form-field>
            </div>
            <!-- Table Undergraduate : EducationLevel = 4 -->
            <mat-label class="label mb-2">Undergraduate Studies</mat-label>
            <div class="col-lg-12">
              <table
                mat-table
                [dataSource]="dataSourceUndergraduate"
                class="table-responsive mb-3"
                style="border: 1px solid #00943a"
                [style.width.%]="100"
                #UndergraduateTable
              >
                <!-- School Column -->
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef [hidden]="true">ID</th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-column"
                    [hidden]="true"
                  >
                    {{ element.id }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="school">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    School
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-cell text-center"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                  >
                    {{ element.school }}
                  </td>
                </ng-container>
                <!-- Course Column -->
                <ng-container matColumnDef="course">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    Course
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                    class="text-center"
                  >
                    {{ element.course }}
                  </td>
                </ng-container>

                <!-- Year Attended -->
                <ng-container matColumnDef="yearAttended">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    Year Attended
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-cell text-center"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                  >
                    {{ element.yearAttended | date : "yyyy" }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="text-center"
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                  ></th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                    class="table-cell"
                  >
                    <div class="d-flex justify-content-end">
                      <div class="row">
                        <div class="col-lg-12">
                          <mat-icon
                            (click)="updateUndergraduate(element)"
                            style="margin-right: 0.3rem"
                            >edit</mat-icon
                          >
                          <mat-icon (click)="deleteItemUndergraduate(element)"
                            >delete</mat-icon
                          >
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-container>
                <tr
                  mat-header-row
                  *matHeaderRowDef="displayedColumnsUndergraduate"
                ></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumnsUndergraduate"
                ></tr>
                <!-- Add Item table row -->
                <tr mat-footer-row *matFooterRowDef="['add-item']"></tr>
              </table>
            </div>
            <!-- Table Graduate : EducationLevel = 4 -->
            <mat-label class="label mb-2">Graduate Studies</mat-label>
            <div class="col-lg-12">
              <table
                mat-table
                [dataSource]="dataSourceGraduate"
                class="table-responsive mb-3"
                style="border: 1px solid #00943a"
                [style.width.%]="100"
                #graduateTable
              >
                <!-- ID -->
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef [hidden]="true">ID</th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-column"
                    [hidden]="true"
                  >
                    {{ element.id }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="school">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    School
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-cell text-center"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                  >
                    {{ element.school }}
                  </td>
                </ng-container>
                <!-- Program -->
                <ng-container matColumnDef="program">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    Program
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                    class="text-center"
                  >
                    {{ element.program }}
                  </td>
                </ng-container>

                <!-- Major -->
                <ng-container matColumnDef="major">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    Major
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-cell text-center"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                  >
                    {{ element.major }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="fieldOfStudy">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    Field of Study
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-cell text-center"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                  >
                    {{ element.fieldOfStudy }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="course">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    Thesis Title
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-cell text-center"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                  >
                    {{ element.thesisTitle }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="yearAttended">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    Year Attended
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-cell text-center"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                  >
                    {{ element.yearAttended | date : "yyyy" }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="text-center"
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                  ></th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                    class="table-cell"
                  >
                    <div class="d-flex justify-content-end">
                      <div class="row">
                        <div class="col-lg-12">
                          <mat-icon
                            (click)="updateGraduate(element)"
                            style="margin-right: 0.3rem"
                            >edit</mat-icon
                          >
                          <mat-icon (click)="deleteItemGraduate(element)"
                            >delete</mat-icon
                          >
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-container>
                <tr
                  mat-header-row
                  *matHeaderRowDef="displayedColumnsGraduate"
                ></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumnsGraduate"
                ></tr>
                <!-- Add Item table row -->
                <tr mat-footer-row *matFooterRowDef="['add-item']"></tr>
              </table>
            </div>
          </div>
          <!-- Post Graduate Studies -->
          <div class="row" *ngIf="highesEducationAttainment == 5">
            <mat-label class="label"> Elementary </mat-label>
            <mat-hint class="filipino-translation-hint">Elementarya</mat-hint>
            <div class="col-lg-8">
              <mat-form-field appearance="outline" [style.width.%]="100">
                <mat-label>School Name</mat-label>
                <input
                  matInput
                  formControlName="elementarySchool"
                  appNoLeadingSpaces
                />
              </mat-form-field>
              <mat-hint class="filipino-translation-hint mb-2"
                >Pangalan ng Paaralan</mat-hint
              >
            </div>
            <div class="col-lg-4">
              <mat-form-field appearance="outline">
                <mat-label>Year Attended</mat-label>
                <input
                  matInput
                  placeholder="YYYY"
                  [matDatepicker]="datePicker"
                  formControlName="elementaryYearAttended"
                  appNoLeadingSpaces
                  (focus)="datePicker?.open()"
                  readonly="true"
                  [max]="maxDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="datePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #datePicker
                  color="primary"
                  startView="multi-year"
                  (yearSelected)="onYearSelectedElementary($event, datePicker)"
                  [startAt]="currentDate"
                ></mat-datepicker>
              </mat-form-field>
            </div>
            <mat-label class="label">Secondary</mat-label>
            <mat-hint class="filipino-translation-hint"
              >Pangalawang lebel (High School/Senior High School/K-12)</mat-hint
            >
            <div class="col-lg-8">
              <mat-form-field appearance="outline" [style.width.%]="100">
                <mat-label>School Name</mat-label>
                <input
                  matInput
                  formControlName="highSchool"
                  appNoLeadingSpaces
                />
              </mat-form-field>
              <mat-hint class="filipino-translation-hint mb-2"
                >Pangalan ng Paaralan</mat-hint
              >
            </div>
            <div class="col-lg-4">
              <mat-form-field appearance="outline">
                <mat-label>Year Attended</mat-label>
                <input
                  matInput
                  placeholder="YYYY"
                  [matDatepicker]="datePickerHighSchool"
                  formControlName="highSchoolYearAttended"
                  appNoLeadingSpaces
                  (focus)="datePicker?.open()"
                  readonly="true"
                  [min]="
                    educationalBackgroundDetailsGroup.get(
                      'elementaryYearAttended'
                    ).value
                  "
                  [max]="maxDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="datePickerHighSchool"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #datePickerHighSchool
                  color="primary"
                  startView="multi-year"
                  (yearSelected)="
                    onYearSelectedSecondary($event, datePickerHighSchool)
                  "
                  [startAt]="currentDate"
                >
                </mat-datepicker>
              </mat-form-field>
            </div>
            <mat-label class="label"
              >Are you part of the K-12 curriculum?</mat-label
            >
            <div class="col-lg-12 mb-2">
              <mat-radio-group
                formControlName="isAttendedSeniorHigh"
                (change)="onk12RadioButtonsSelect()"
              >
                <mat-radio-button [value]="true" class="radio-buttons-left"
                  >Yes
                </mat-radio-button>
                <mat-radio-button [value]="false" class="radio-buttons-right"
                  >No</mat-radio-button
                >
              </mat-radio-group>
              <!-- <mat-error class="mt-2" *ngIf="showMessagek12 == true">{{
                    errorMessagek12
                  }}</mat-error> -->
            </div>
            <div
              class="col-lg-6"
              *ngIf="
                this.educationalBackgroundDetailsGroup.controls
                  .isAttendedSeniorHigh.value == true
              "
            >
              <mat-form-field appearance="outline" [style.width.%]="100">
                <mat-label>School Name</mat-label>
                <input
                  matInput
                  formControlName="seniorHighSchool"
                  appNoLeadingSpaces
                />
              </mat-form-field>
              <mat-hint class="filipino-translation-hint mb-2"
                >Pangalan ng Paaralan</mat-hint
              >
            </div>
            <div
              class="col-lg-6"
              *ngIf="
                this.educationalBackgroundDetailsGroup.controls
                  .isAttendedSeniorHigh.value == true
              "
            >
              <mat-form-field appearance="outline" [style.width.%]="100">
                <mat-label>Senior High Strand</mat-label>
                <mat-select formControlName="seniorHighSchoolStrands">
                  <mat-option
                    *ngFor="let strand of k12Strands"
                    [value]="strand.name"
                  >
                    {{ strand.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-hint class="filipino-translation-hint mb-2">Strand</mat-hint>
            </div>
            <div
              class="col-lg-6"
              *ngIf="
                this.educationalBackgroundDetailsGroup.controls
                  .isAttendedSeniorHigh.value == true
              "
            >
              <mat-form-field appearance="outline" [style.width.%]="100">
                <mat-label>Level Reached</mat-label>
                <mat-select formControlName="seniorHighSchoolLevelReached">
                  <mat-option
                    *ngFor="let k12Level of k12Levels"
                    [value]="k12Level.name"
                  >
                    {{ k12Level.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-hint class="filipino-translation-hint mb-2"
                >Naabot ang Antas</mat-hint
              >
            </div>
            <div
              class="col-lg-6"
              *ngIf="
                this.educationalBackgroundDetailsGroup.controls
                  .isAttendedSeniorHigh.value == true
              "
            >
              <mat-form-field appearance="outline">
                <mat-label>Year Attended</mat-label>
                <input
                  matInput
                  placeholder="YYYY"
                  [matDatepicker]="datePickerHighk12"
                  formControlName="seniorHighSchoolYearAttended"
                  appNoLeadingSpaces
                  (focus)="datePicker?.open()"
                  readonly="true"
                  [min]="
                    educationalBackgroundDetailsGroup.get(
                      'highSchoolYearAttended'
                    ).value
                  "
                  [max]="maxDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="datePickerHighk12"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #datePickerHighk12
                  color="primary"
                  startView="multi-year"
                  (yearSelected)="
                    onYearSelectedK12($event, datePickerHighSchool)
                  "
                  [startAt]="currentDate"
                >
                </mat-datepicker>
              </mat-form-field>
            </div>
            <!-- Multiple Undergraduate Studies : educationLevel = 5-->
            <mat-label class="label mb-2">Undergraduate Studies</mat-label>
            <div class="col-lg-12">
              <table
                mat-table
                [dataSource]="dataSourceUndergraduate"
                class="table-responsive mb-3"
                style="border: 1px solid #00943a"
                [style.width.%]="100"
                #UndergraduateTable
              >
                <!-- School Column -->
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef [hidden]="true">ID</th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-column"
                    [hidden]="true"
                  >
                    {{ element.id }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="school">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    School
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-cell text-center"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                  >
                    {{ element.school }}
                  </td>
                </ng-container>
                <!-- Course Column -->
                <ng-container matColumnDef="course">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    Course
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                    class="text-center"
                  >
                    {{ element.course }}
                  </td>
                </ng-container>

                <!-- Year Attended -->
                <ng-container matColumnDef="yearAttended">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    Year Attended
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-cell text-center"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                  >
                    {{ element.yearAttended | date : "yyyy" }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="text-center"
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                  ></th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                    class="table-cell"
                  >
                    <div class="d-flex justify-content-end">
                      <div class="row">
                        <div class="col-lg-12">
                          <mat-icon
                            (click)="updateUndergraduate(element)"
                            style="margin-right: 0.3rem"
                            >edit</mat-icon
                          >
                          <mat-icon (click)="deleteItemUndergraduate(element)"
                            >delete</mat-icon
                          >
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-container>
                <tr
                  mat-header-row
                  *matHeaderRowDef="displayedColumnsUndergraduate"
                ></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumnsUndergraduate"
                ></tr>
                <!-- Add Item table row -->
                <tr mat-footer-row *matFooterRowDef="['add-item']"></tr>
              </table>
            </div>
            <!-- Multiple Graduate Studies : educationLevel = 5 -->
            <mat-label class="label mb-2">Graduate Studies</mat-label>
            <div class="col-lg-12">
              <table
                mat-table
                [dataSource]="dataSourceGraduate"
                class="table-responsive mb-3"
                style="border: 1px solid #00943a"
                [style.width.%]="100"
                #graduateTable
              >
                <!-- ID -->
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef [hidden]="true">ID</th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-column"
                    [hidden]="true"
                  >
                    {{ element.id }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="school">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    School
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-cell text-center"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                  >
                    {{ element.school }}
                  </td>
                </ng-container>

                <!-- Program -->
                <ng-container matColumnDef="program">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    Program
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                    class="text-center"
                  >
                    {{ element.program }}
                  </td>
                </ng-container>

                <!-- Major -->
                <ng-container matColumnDef="major">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    Major
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-cell text-center"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                  >
                    {{ element.major }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="fieldOfStudy">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    Field of Study
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-cell text-center"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                  >
                    {{ element.fieldOfStudy }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="course">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    Thesis Title
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-cell text-center"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                  >
                    {{ element.thesisTitle }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="yearAttended">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    Year Attended
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-cell text-center"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                  >
                    {{ element.yearAttended | date : "yyyy" }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="text-center"
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                  ></th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                    class="table-cell"
                  >
                    <div class="d-flex justify-content-end">
                      <div class="row">
                        <div class="col-lg-12">
                          <mat-icon
                            (click)="updateGraduate(element)"
                            style="margin-right: 0.3rem"
                            >edit</mat-icon
                          >
                          <mat-icon (click)="deleteItemGraduate(element)"
                            >delete</mat-icon
                          >
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-container>
                <tr
                  mat-header-row
                  *matHeaderRowDef="displayedColumnsGraduate"
                ></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumnsGraduate"
                ></tr>
                <!-- Add Item table row -->
                <tr mat-footer-row *matFooterRowDef="['add-item']"></tr>
              </table>
            </div>
            <!-- Table Post Graduate -->
            <mat-label class="label mb-2">Post Graduate Studies</mat-label>
            <div class="col-lg-12">
              <table
                mat-table
                [dataSource]="dataSourcePostGraduate"
                class="table-responsive mb-3"
                style="border: 1px solid #00943a"
                [style.width.%]="100"
                #postGraduateTable
              >
                <!-- ID -->
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef [hidden]="true">ID</th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-column"
                    [hidden]="true"
                  >
                    {{ element.id }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="school">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    School
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-cell text-center"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                  >
                    {{ element.school }}
                  </td>
                </ng-container>

                <!-- Program -->
                <ng-container matColumnDef="program">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    Program
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                    class="text-center"
                  >
                    {{ element.program }}
                  </td>
                </ng-container>
                <!-- Major -->
                <ng-container matColumnDef="major">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    Major
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-cell text-center"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                  >
                    {{ element.major }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="dissertationTitle">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    Dissertation Title
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-cell text-center"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                  >
                    {{ element.dissertationTitle }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="fieldOfStudy">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    Field of Study
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-cell text-center"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                  >
                    {{ element.fieldOfStudy }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="researchInterest">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    Research of Interest
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-cell text-center"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                  >
                    {{ element.researchInterests }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="publications">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    Publications
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-cell text-center"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                  >
                    {{ element.publications }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="yearAttended">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="text-center"
                  >
                    Year Attended
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="table-cell text-center"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                  >
                    {{ element.yearAttended | date : "yyyy" }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="text-center"
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #00943a;
                      background-color: #00943a;
                      color: #ffffff;
                      font-size: 14px;
                    "
                  ></th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    style="padding: 1rem; border-bottom: 1px solid #00943a"
                    class="table-cell"
                  >
                    <div class="d-flex justify-content-end">
                      <div class="row">
                        <div class="col-lg-12">
                          <mat-icon
                            (click)="updatePostGraduate(element)"
                            style="margin-right: 0.3rem"
                            >edit</mat-icon
                          >
                          <mat-icon (click)="deletePostItemGraduate(element)"
                            >delete</mat-icon
                          >
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-container>
                <tr
                  mat-header-row
                  *matHeaderRowDef="displayedColumnsPostGraduate"
                ></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumnsPostGraduate"
                ></tr>
                <!-- Add Item table row -->
                <tr mat-footer-row *matFooterRowDef="['add-item']"></tr>
              </table>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-lg-12">
              <div class="d-flex justify-content-end">
                <button
                  mat-raised-button
                  color="primary"
                  class="text-white me-3"
                  (click)="updateEducationalDetails()"
                >
                  Update
                </button>
                <button
                  mat-raised-button
                  (click)="cancelEditModeEducationalBackgroundDetails()"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div *ngIf="selectedNav === 'eligibilityProfessionalLicense'">
      <div class="row section">
        <table
          mat-table
          [dataSource]="dataSoruceEligibilityProfessioalLicense"
          class="table-items mb-3"
          style="border: 1px solid #00943a"
          #eligibilityLicenseTable
        >
          <!-- ID -->
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef [hidden]="true">ID</th>
            <td
              mat-cell
              *matCellDef="let element"
              class="table-column"
              [hidden]="true"
            >
              {{ element.id }}
            </td>
          </ng-container>

          <!-- License Type -->
          <ng-container matColumnDef="licenseType">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="table-heading"
            >
              License Type
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="table-cell table-heading-element"
            >
              {{ element.licenseType }}
            </td>
          </ng-container>
          <!-- Eligibility Column -->
          <ng-container matColumnDef="eligibilityLevel">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="table-heading"
            >
              Eligibility Level
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="table-cell text-center"
              style="border-bottom: 1px solid #00943a"
            >
              {{ element.eligibilityLevel ? element.eligibilityLevel : "-" }}
            </td>
          </ng-container>

          <!-- Date taken Column -->

          <ng-container matColumnDef="dateTaken">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="table-heading"
            >
              Date taken
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="table-cell table-heading-element"
            >
              <!-- Use *ngIf to conditionally display the date -->
              <ng-container *ngIf="element.takenDate">
                {{ element.takenDate | date : "shortDate" }}
              </ng-container>
              <ng-container *ngIf="!element.takenDate"> - </ng-container>
            </td>
          </ng-container>

          <!-- PRC License Column -->
          <ng-container matColumnDef="prcLicense">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="table-heading"
            >
              PRC License
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="table-cell table-heading-element"
            >
              {{ element.prc ? element.prc : "-" }}
            </td>
          </ng-container>

          <!-- Valid Until Column -->
          <ng-container matColumnDef="validUntil">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="table-heading"
            >
              Valid Until
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="table-cell table-heading-element"
            >
              <!-- Use *ngIf to conditionally display the date -->
              <ng-container *ngIf="element.validUntilDate">
                {{ element.validUntilDate | date : "shortDate" }}
              </ng-container>
              <ng-container *ngIf="!element.validUntilDate"> - </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="table-heading"
            ></th>

            <td
              mat-cell
              *matCellDef="let element"
              class="table-cell table-heading-element"
            >
              <div class="d-flex justify-content-end">
                <div class="row">
                  <div class="col-lg-12">
                    <mat-icon
                      (click)="updateItemLicense(element)"
                      style="margin-right: 0.3rem"
                      >edit</mat-icon
                    >
                    <mat-icon (click)="deleteItemLicense(element)"
                      >delete</mat-icon
                    >
                  </div>
                </div>
              </div>
            </td>
          </ng-container>
          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumnsEligibilityProfessionalLicense"
          ></tr>
          <tr
            mat-row
            *matRowDef="
              let row;
              columns: displayedColumnsEligibilityProfessionalLicense
            "
          ></tr>
          <!-- Add Item Table Row -->
          <tr
            mat-footer-row
            class="example-second-footer-row"
            style="border-bottom: 1px solid #00943a text-center"
          ></tr>
        </table>
      </div>
    </div>
    <div *ngIf="selectedNav === 'workExpercience'">
      <div class="row section">
        <table
          mat-table
          [dataSource]="dataSourceWorkExperience"
          class="table-items mb-3"
          style="border: 1px solid #00943a"
          #workHistoryTable
        >
          <!-- id Column -->
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef [hidden]="true">id</th>
            <td
              mat-cell
              *matCellDef="let element"
              class="table-cell"
              [hidden]="true"
            >
              {{ element.id }}
            </td>
          </ng-container>

          <!-- Company Column -->
          <ng-container matColumnDef="companyName">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="table-heading"
            >
              Company
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="text-center table-heading-element"
            >
              {{ element.companyName }}
            </td>
          </ng-container>

          <!-- Country Column -->
          <ng-container matColumnDef="country">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="table-heading"
            >
              Country
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="table-cell table-heading-element"
            >
              {{ element.country }}
            </td>
          </ng-container>

          <!-- City/Municipality Column -->
          <ng-container matColumnDef="cityMunicipality">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="table-heading"
            >
              Address
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="table-cell table-heading-element"
            >
              {{ element.cityName }}
            </td>
          </ng-container>

          <!-- Start of Contract Column -->
          <ng-container matColumnDef="startOfContractDate">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="table-heading"
            >
              Start of Contract
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="text-center table-heading-element"
            >
              {{ element.startOfContractDate | date : "shortDate" }}
            </td>
          </ng-container>

          <!-- End of Contract Column -->
          <ng-container matColumnDef="endOfContractData">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="table-heading"
            >
              End of Contract
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="text-center table-heading-element"
            >
              {{ element.endOfContractData | date : "shortDate" }}
            </td>
          </ng-container>

          <!-- Occupation Column -->
          <ng-container matColumnDef="occupation">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="table-heading"
            >
              Occupation
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="table-cell table-heading-element"
              style="border-bottom: 1px solid #00943a"
            >
              {{ element.occupation }}
            </td>
          </ng-container>

          <!-- Employment type Column -->
          <ng-container matColumnDef="employmentType">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="table-heading"
            >
              Employment Type
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="table-cell table-heading-element"
            >
              {{ element.employmentType }}
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="table-heading"
            ></th>
            <td
              mat-cell
              *matCellDef="let element"
              class="table-cell table-heading-element"
            >
              <div class="d-flex justify-content-end">
                <div class="row">
                  <div class="col-lg-12">
                    <mat-icon
                      (click)="updateWorkExpercience(element)"
                      style="margin-right: 0.3rem"
                      >edit</mat-icon
                    >
                    <mat-icon (click)="deleteItemWorkExpercience(element)"
                      >delete</mat-icon
                    >
                  </div>
                </div>
              </div>
            </td>
          </ng-container>
          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumnsWorkExpercience"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumnsWorkExpercience"
          ></tr>

        </table>
      </div>
    </div>
    <div *ngIf="selectedNav === 'otherSkillsWithoutCertificate'">
      <div class="row section">
        <mat-label class="label mb-2"
          >Other Skills Without Certificate</mat-label
        >
        <div class="row">
          <mat-form-field
            appearance="legacy"
            class="example-chip-list"
            [style.width.%]="100"
          >
            <mat-label>Skills</mat-label>
            <mat-autocomplete
              #autoFruits="matAutocomplete"
              (optionSelected)="selected($event)"
            >
              <mat-option
                *ngFor="let fruit of filteredFruits | async"
                [value]="fruit"
              >
                {{ fruit }}
              </mat-option>
            </mat-autocomplete>
            <mat-chip-list #chipList aria-label="Fruit selection">
              <mat-chip
                *ngFor="let fruit of fruits"
                [selectable]="selectable"
                [removable]="removable"
                (removed)="remove(fruit)"
                [disabled]="true"
              >
                {{ fruit }}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
              </mat-chip>
              <input
                class="inputs-skills"
                style="padding-top: 0px; padding-bottom: 10px"
                #fruitInput
                [formControl]="fruitCtrl"
                [matAutocomplete]="autoFruits"
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="addOnBlur"
                (matChipInputTokenEnd)="add($event)"
                readonly="true"
              />
            </mat-chip-list>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div *ngIf="selectedNav === 'identification'">
      <div class="row section">
        <div class="col-12 col-lg-8">
          <mat-label class="label-title">Identification Details</mat-label>
        </div>
        <form [formGroup]="identificationDetailsGroup">
          <div class="row mt-3">
            <p class="mb-1">
              Upload front photo of your valid identification card and fill out
              the required details.Include dashes (-) in your ID number
            </p>
            <mat-hint class="filipino-translation-hint mb-2">
              Mag-upload ng larawan sa harap ng iyong wastong identification
              card at punan ang mga kinakailangang detalye. Isama ang mga
              gitling (-) sa iyong ID number</mat-hint
            >
          </div>
          <div class="row mb-3">
            <mat-form-field appearance="outline" [style.width.%]="100">
              <mat-select
                [(ngModel)]="selectedIDType"
                formControlName="dropdown"
                [disabled]="true"
              >
                <mat-option *ngFor="let item of idTypes" [value]="item.id">
                  {{ item.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="row">
            <mat-form-field appearance="outline" [style.width.%]="100">
              <input
                matInput
                formControlName="pattern"
                type="text"
                placeholder=""
                readonly="true"
              />
            </mat-form-field>
            <mat-hint class="filipino-translation-hint mb-2">
              Numero ng ID
            </mat-hint>
          </div>
          <div class="row" *ngIf="selectedIDType == 1">
            <div>
              <ngx-dropzone
                [multiple]="false"
                (change)="onSelectPhotoName($event)"
                accept="image/jpeg,image/jpg,image/png,image"
                style="height: auto"
              >
                <div class="image-container">
                  <div class="image-container">
                    <div *ngIf="selectedPhotoName">
                      <img
                        [src]="this.selectedPhotoName"
                        alt=""
                        class="id-upload"
                        (error)="onImageError($event)"
                      />
                    </div>
                    <div
                      class="container"
                      style="margin-top: 115px; margin-bottom: 115px"
                    >
                      <div *ngIf="!selectedPhotoName">
                        {{
                          existingFileName
                            ? existingFileName
                            : "Click here to upload passport."
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </ngx-dropzone>
            </div>
          </div>
          <div class="row" *ngIf="selectedIDType != 1">
            <div class="col col-lg-12 mb-3">
              <ngx-dropzone
                [multiple]="false"
                (change)="onSelectIDFront($event)"
                accept="image/jpeg,image/jpg,image/png,image"
                style="height: auto"
              >
                <div class="image-container">
                  <div class="image-container">
                    <div *ngIf="selectedFileFront">
                      <img
                        [src]="this.selectedFileFront"
                        alt=""
                        class="id-upload"
                        (error)="onImageError($event)"
                      />
                    </div>
                    <div
                      class="container"
                      style="margin-top: 115px; margin-bottom: 115px"
                    >
                      <div *ngIf="!selectedFileFront">
                        {{
                          existingFileName
                            ? existingFileName
                            : "Click here to upload front photo."
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </ngx-dropzone>
            </div>
          </div>
          <div *ngIf="selectedIDType != 1" class="col mt-3">
            <ngx-dropzone
              [multiple]="false"
              (change)="onSelectBackID($event)"
              accept="image/jpeg,image/jpg,image/png"
              style="height: auto"
            >
              <div class="image-container">
                <div class="image-container">
                  <div *ngIf="selectedIDBack">
                    <img
                      [src]="this.selectedIDBack"
                      alt=""
                      class="id-upload"
                      (error)="onImageError($event)"
                    />
                  </div>
                  <div
                    class="container"
                    style="margin-top: 115px; margin-bottom: 115px"
                  >
                    <div *ngIf="!selectedIDBack">
                      {{
                        existingFileName
                          ? existingFileName
                          : "Click here to upload back photo."
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </ngx-dropzone>
          </div>
          <div class="row">
            <div class="row mb-2">
              <div>
                <p class="mb-1 mt-3">
                  Upload a selfie with your valid identification card. Ensure
                  photo and details in the card are clearly shown.
                </p>
              </div>
              <mat-hint class="filipino-translation-hint mb-2">
                Mag-upload ng selfie gamit ang iyong valid identification card.
                Tiyaking malinaw na ipinapakita ang larawan at mga detalye sa
                card.</mat-hint
              >
            </div>
            <div class="col col-lg-12">
              <ngx-dropzone
                [multiple]="false"
                (change)="onSelectSelfie($event)"
                accept="image/jpeg,image/jpg,image/png"
                style="height: auto"
              >
                <div class="image-container">
                  <div class="image-container">
                    <div *ngIf="selectedID">
                      <img
                        [src]="this.selectedID"
                        alt=""
                        class="id-upload"
                        (error)="onImageError($event)"
                      />
                    </div>
                    <div
                      class="container"
                      style="margin-top: 115px; margin-bottom: 115px"
                    >
                      <div *ngIf="!selectedID">
                        {{
                          existingSelfieFileName
                            ? existingSelfieFileName
                            : "Click here to upload selfie with ID."
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </ngx-dropzone>
            </div>
          </div>
        </form>
      </div>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
